import * as React from 'react';

import ROUTES from 'platform/constants/routes';
import Settings from 'platform/services/settings';

const cardInfo = <>
  <p>Հարգելի հաճախորդներ, Ալֆա Ֆարմ դեղատների ցանցը 01.11.2016թ․-ից գործարկում է հաճախորդների խրախուսման նոր բոնուսային ծրագիր, որը հնարավորություն է ընձեռում հաճախորդներին կատարելով գնումներ Ալֆա Ֆարմ դեղատներից, դրանց դիմաց կուտակել միավորներ և ծախսել ցանկացած ժամանակ: Միավորները կուտակվում են կախված կատարված գնումների գումարի չափից, ինչպես նաև քարտապանները հնարավորություն կունենան կուտակել ԲԱՐՁՐ միավորներ՝ կատարելով գնումներ կիրակի օրերին, ընտրելով իրենց կողմից հաճախակի գնվող 2 ապրանքատեսակ կամ գնելով նշված ապրանքանիշերի տեսականուց։</p>
  <h4>«ԱլֆաՔարտ» Բոնուսային ծրագիր</h4>
  <p>Ներկայացրեք «ԱլֆաՔարտ»-ը և կուտակեք միավորներ ըստ հետևյալ սանդղակի.</p>


  <ul>
    <li>2 միավոր  յուրաքանչյուր 100 դրամի դիմաց` մինչև 10 000 դրամ միանվագ գնում կատարելու դեպքում</li>
    <li>3 միավոր յուրաքանչյուր 100 դրամի դիմաց` 10 000-ից մինչև 20 000 դրամ միանվագ գնում կատարելու դեպքում</li>
    <li>5 միավոր  յուրաքանչյուր 100 դրամի դիմաց` 20 000 դրամ և ավել միանվագ գնում կատարելու դեպքում</li>
    <li>+1 լրացուցիչ միավոր յուրաքանչյուր 100 դրամի դիմաց` 40 000 դրամ և ավել միանվագ գնում կատարելու դեպքում</li>
    <li>+1 լրացուցիչ միավոր յուրաքանչյուր 100 դրամի դիմաց՝  կիրակի օրերին գնումներ կատարելիս</li>
  </ul>

  <p>Նաև հնարավորություն ունեք կուտակել բարձր միավորներ`</p>

  <ul>
    <li>ընտրեք կամայական երկու Հատուկ ապրանքատեսակ և կուտակեք ավելի շատ՝  յուրաքանչյուր 100 դրամի դիմաց, կախված ապրանքատեսակից: Ապրանքները կարող են փոփոխվել ամեն 3 ամիսը մեկ:</li>
    <li>կուտակեք հատուկ բարձր միավորներ յուրաքանչյուր 100 դրամի դիմաց` հետևյալ ապրանքանիշերի ապրանքատեսակները գնելիս. Avene,Vichy, La Roche-Posay, Ducray, Bambo, Mustela, Bebble, Maternea, Derma, Canpol, Abena, Lavena, Abri, Bioderma, Swiss image, Swiss code, Vetia floris, Himalaya:</li>
  </ul>

  <p>Վերոնշյալ կուտակումների դեպքում ստանդարտ կուտակման սանդղակը չի գործում։</p>

  <p>Ցածր միավորներ կարող են տրամադրվել կամ ընդհանրապես չտրամադրվել ընկերության կողմից   որոշ փոքրաքանակ ապրանքախմբերի համար, որոնք վաճառվում են ցածր գներով կամ Հատուկ զեղչով:</p>
  <p>Առանձին ակցիաների դեպքում դրանց կուտակման պայմանները սահմանվում են առանձին-առանձին։</p>
  <p>Կուտակված միավորներն օգտագործելիս դրանց դիմաց նոր միավորներ չեն կուտակվում։ </p>
  <p>Մեկ տարուց ավել քարտը չօգտագործելու դեպքում այն ավտոմատ կարգելափակվի և միավորները կզրոյացվեն:</p>

  <h4>«Ալֆա Քարտ» - «Բոնուսային» ծրագիր կորպորատիվ հաճախորդների համար</h4>
  <p>«Ալֆա Քարտ» կորպորատիվ հաճախորդների բոնուսային կուտակային ծրագիրը հնարավորություն է ընձեռում հաճախորդներին կատարել գնումներ «Ալֆա-Ֆարմ» դեղատներից, դրանց դիմաց կուտակել միավորներ և ծախսել ցանկացած ժամանակ` մաս-մաս կամ ամբողջությամբ (1 միավորի արժեքը 1 դրամ է): Միավորները կուտակվում են կախված հաճախորդի միանվագ կատարված գնումների գումարի չափից` ըստ հետևյալ սանդղակի.</p>

  <ul>
    <li>6 միավոր  յուրաքանչյուր 100 դրամի դիմաց` մինչև 10 000 դրամ միանվագ գնում կատարելու դեպքում</li>
    <li>7 միավոր յուրաքանչյուր 100 դրամի դիմաց` 10 000-ից մինչև 20 000 դրամ միանվագ գնում կատարելու դեպքում</li>
    <li>9 միավոր  յուրաքանչյուր 100 դրամի դիմաց` 20 000 դրամ և ավել միանվագ գնում կատարելու դեպքում</li>
    <li>+1 լիացուցիչ միավոր յուրաքանչյուր 100 դրամի դիմաց` 40 000 դրամ և ավել միանվագ գնում կատարելու դեպքում</li>
  </ul>

  <p>Քարտապանը հնարավորություն ունի նաև հիմնական սանդղակից զատ կուտակել լրացուցիչ բարձր միավորներ`</p>

  <ul>
    <li>«Հատուկ» բարձր միավորներ յուրաքանչյուր 100 դրամի դիմաց` յուրաքանչյուր քարտապան ունի հնարավորություն նշել 2 «Հատուկ ապրանքատեսակ», որը նա կարող է գնել և ստանալ լրացուցիչ միավորներ: Ապրանքները կարող են փոփոխվել ամեն 3 ամիսը մեկ: Նշյալ կուտակումների դեպքում ստանդարտ կուտակման սանդղակը չի գործում։</li>
    <li>«Հատուկ» բարձր միավորներ յուրաքանչյուր 100 դրամի դիմաց` յուրաքանչյուր քարտապան ունի հնարավորություն կուտակել բարձր միավորներ հետևյալ ապրանքանիշերի ապրանքատեսակները գնելիս` Avene, Vichy, La-Roche-Posay, Ducray, Bambo, Mustela, Bebble, Maternea, Derma, Canpol, Abena, Lavena, Abri, Bioderma, Swiss image, Himalaya:  Նշյալ կուտակումների դեպքում ստանդարտ կուտակման սանդղակը չի գործում։</li>
    <li>+1 լրացուցիչ միավոր յուրաքանչյուր 100 դրամի դիմաց` յուրաքանչյուր քարտապան կունենա հնարավորություն կուտակել բարձր միավորներ կատարելով գնումներ ամսվա կիրակի օրերին:</li>
  </ul>

  <p>*1 տարուց ավել քարտը չօգտագործելու դեպքում, այն ավտոմատ կարգելափակվի:</p>
  <p>*Ցածր միավորներ կարող են տրամադրվել կամ ընդհանրապես չտրամադրվել ընկերության կողմից սահմանված որոշ փոքրաքանակ ապրանքախմբերի համար, որոնք վաճառվում են ցածր գներով կամ «Հատուկ զեղչով»-ով:</p>
  <p>* Առանձին ակցիաների դեպքում դրանց կուտակման պայմանները սահմանվում են առանձին-առանձին։</p>
  <p>*Կուտակված միավորներն օգտագործելիս դրանց դիմաց նոր միավորներ չեն կուտակվում։ </p>
  <p>Մեկ տարուց ավել քարտը չօգտագործելու դեպքում այն ավտոմատ կարգելափակվի և միավորները կզրոյացվեն:</p>
</>;

const contactText = <>
  Հարգելի հաճախորդներ, <br /> <br />
  Շնորհակալություն ենք հայտնում մեր առաջարկած ծառայությունների նկատմամբ հետաքրքրություն ցուցաբերելու համար <br />
  Մենք աշխատում ենք բարձրացնել մեր կողմից առաջարկվող ծառայությունների որակը, ինչի համար կարևորում ենք հետադարձ կապը մեր հաճախորդների հետ: <br />
  Առաջացած հարցերի կամ խնդիրների դեպքում խնդրում ենք լրացնել ստորև նշված տողերը կամ զանգահարել <br />
  <b>011 200 900</b> հեռախոսահամարով: <br /> <br />
  <address>
    ԿՐՈՄԱ ԳՐՈՒՊ ՍՊԸ <br />
    0060, ՀՀ, ք. Երեւան, Ավան 4/14 <br />
    ՀՎՀՀ 00888954 <br />
    ԱՄԵՐԻԱԲԱՆԿ ՓԲԸ <br />
    Գր.Լուսավորիչ փող 9 <br />
    հ/հ 1570020377270100
  </address>
</>;

const contractText = <>
  1. Սույն պայմանագիրը (այսուհետ՝ Պայմանագիր) սահմանում և կարգավորում է &lt;&lt;Կրոմա Գրուպ&gt;&gt; ՍՊ ընկերության (այսուհետ նաև՝ Ընկերություն) ineed.am կայքով (այսուհետ նաև ՝ Կայք) Ընկերության կողմից մատուցվող ծառայությունների հետ կապված իրավահարաբերությունները:<br /><br />
  2. Մուտք գործելով Կայք, օգտագործելով Կայքի ցանկացած ծառայություն կամ ներբեռնելով ցանկացած բովանդակություն՝ ամբողջությամբ կամ դրա մի մասը Դուք, որպես օգտագործող (այսուհետ նաև՝ Օգտագործող, Դուք, Ձեզ, Ձեր, Հաճախորդ) հաստատում եք, որ ամբողջությամբ կարդացել և հասկացել եք Պայմանագիրը, ինչպես նաև Կայքում հրապարակված Ընկերության կողմից Ծառայությունների մատուցման այլ պայմանները (այսուհետ նաև՝ Պայմաններ կամ Պայմանագիր) և անվերապահորեն ընդունում եք դրանք, անկախ նրանից՝ Դուք Ընկերության կողմից մատուցվող Ծառայությունների հաճախորդ եք, Կայքի գրանցված օգտագործող, թե՝ ուղղակի այցելու:<br /><br />
  3. Ընկերությունն իրավունք ունի առանց նախապես ծանուցման, միակողմանի, ցանկացած պահի փոփոխել Պայմանագիրը: Այդ դեպքում փոփոխված Պայմանագիրը կտեղադրվի Կայքում՝ նշելով վերջին փոփոխության ամսաթիվը: Օգտագործողի պարտականությունն է Կայք այցելելիս ծանոթանալ Պայմանագրի փոփոխություններին (առկայության դեպքում): Փոփոխություններն ուժի մեջ են մտնում Կայքում տեղադրելու օրվանից եվ տարածվում են դրանից հետո ծագած հարաբերությունների վրա:<br /><br />
  4. Եթե Դուք համաձայն չեք Պայմանագրին, անհրաժեշտ է դադարեցնել Կայքի օգտագործումը: Կայքում գտնվելը, հաշիվ բացելը, Օգտագործող դառնալը և Ծառայություններից օգտվելը փաստում են Ձեր կողմից Պայմանագրի պայմանների անվերապահ ընդունումը եվ կնքումը:<br /><br />
  5. Կնքելով Պայմանագիրը՝ Դուք հաստատում եք, որ լրիվ գործունակ եք և իրավունք ունեք օգտվել Ծառայություններից: Եթե Դուք ներկայացնում եք իրավաբանական անձ, ապա Դուք հավաստում եք, որ իրավասու եք իրավաբանական անձի անունից օտվել Ծառայություններից: Համաձայնվելով սույն պայմաններին, Դուք ընդունում եք, որ Ընկերությունը չի կարող ստուգել Ձեր տված տեղեկությունները և տվյալները, այս կետում տրված Ձեր հավաստումների իսկությունը, ուստի սույն կետի յուրաքանչյուր խախտման ամբողջական պատասխանատվությունը ընկնում է Ձեզ վրա:<br /><br />
  6. Ընկերության կողմից մատուցվող Ծառայություններից ողջ ծավալով օգտվելու համար Դուք պետք է գրանցվեք Կայքում և ստեղծեք Անձնական էջ (այսուհետ նաև՝ Օգտագործողի անձնական էջ կամ Անձնական էջ): Յուրաքանչյուր Օգտագործող կարող է ունենալ մեկ Անձնական էջ: Օգտագործողներն իրավունք չունեն օգտագործել այլ Օգտագարծողի Անձնական էջը: Անձնական էջը բացելիս Օգտագործողը պարտավոր է ճշմարիտ ներկայացնել պահանջվող ողջ տեղեկատվությունը: Օգտագործողներն իրենք են պատասխանատու իրենց Անձնական էջի մուտքի տվյալների պահպանման համար և իրենք են կրում իրենց Անձնական էջով կատարվող գործառնությունների/գործողությունների համար պատասխանատվություն: Օգտագործողը պարտավոր է անհապաղ տեղեկացնել Ընկերությանը, եթե վստահ է, որ իր Անձնական էջ եղել է չթույլատրված մուտք: Նման դեպքում Ընկերությունը իրավունք ունի անմիջապես արգելափակել Անձնական էջը ՝ մինչև հանգամանքների ամբողջական պարզումը: Ամեն դեպքում Ընկերությունը չի կրում ոչ մի պատասխանատվություն այլ անձանց կողմից Օգտագործողի Անձնական էջով կատարված գործողությունների համար: Այդ գործողություններով Ընկերությանը կամ երրորդ անձանց պատճառված վնասի համար պատասխանատվություն է կրում Օգտագործողը:<br /><br />
  7. Ընկերության կողմից մատուցվող Ծառայությունները ներառում են սակայն չեն սահմանափակվում հետևյալով՝<br />
  <ul>
    <li>Ընկերության միջոցով գնված ապրանքների տեղափոխման կազմակերպում Հաճախորդներին:</li>
    <li>Հաճախորդների կողմից ինքուրույն գնված ապրանքների տեղափոխության կազմակերպում:</li>
    <li>Հաճախորդների ապրանքների պահեստավորում:</li>
  </ul>
  8. Ընկերությունն իրավունք ունի իր հայեցողությամբ մերժել Ծառայության մատուցումը յուրաքանչյուր ֆիզիկական կամ իրավաբանական անձին դրա կատարման հնարավորության բացակայության դեպքում:<br /><br />
  9. Ընկերությունն իրավունք ունի այն ժամանակահատվածում, երբ պատվերների ընդհանուր ծավալը մեծանում է (տոնական օրեր, զեղչային ծրագրեր կամ միջոցառումներ և այլն) հետաձգել պատվերների առաքման ժամկետները, ինչպես նաև կասեցնել որոշակի Ծառայությունների մատուցումը:<br /><br />
  10. Պատվերը տեղ է հասցվում ուղեկցող փաստաթղթի վրա նշված հասցեով և հանձնվում է Պատվերը ստացողին կամ նրա կողմից լիազորված անձին` ստորագրությամբ: Պատվերն ստացող անձը հաստատում է ստացումը և ուղեկցող փաստաթղթի վրա նշում`<br />
  <ul>
    <li>անունը և ազգանունը,</li>
    <li>ստորագրությունը,</li>
    <li>Պատվերի հանձնման օրը և ժամը:</li>
    <li>Պատվերի ամբողջականության և լիարժեքության վերաբերյալ գրավոր նշում</li>
  </ul>
  11. Պատվերները ստացողին (օրինական ներկայացուցչին) հանձնելու անհնարինության դեպքում դրանք 30 օր պահպանվում են Ընկերության պահեստում: Ուղարկողը կամ ստացողը պայմանագրով կարող է երկարաձգել Պատվերի պահպանման ժամկետները: Պատվիրատու վճարում է Պատվերի պահպանման համար: Այն դեպքում, եթե Պատվերը չի ընդունվում հասցեատիրոջ կողմից 30 օրվա ընթացքում և բացակայում է համապատասխան պայմանագիրը պահպանման ժամկետը երկարացնելու համար, Ընկերությունը իրավունք ունի օտարել Պատվերը, իրեն հարմար գնով, ստացված գումարից պահել իր կողմից կատարված բոլոր ծախսերը, իսկ մնացած գումարը վերադարձնել Հաճախորդին կամ հանձնել նոտարի կամ փաստաբանի դեպոզիտ:<br /><br />
  12. Պատվերը հանձնվում է, եթե առկա է անձը հաստատող փաստաթուղթ, վարորդական վկայական, զինգրքույկ:<br /><br />
  13. Ծառայությունների մատուցման պարտականությունները չկատարելու կամ ոչ պատշաճ կատարելու դեպքում, Հաճախորդներն իրավունք ունեն Ընկերությանը կամ վերջինիս գործընկեր կազմակերպությանը ներկայացնել գրավոր պահանջ (բողոք):<br /><br />
  14. Գրավոր պահանջում (բողոքում) նշվում է`<br />
  <ul>
    <li>դիմումատուի (օրինական ներկայացուցչի) անձը հաստատող փաստաթղթի տվյալները,</li>
    <li>պահանջի (բողոքի) էությունը:</li>
  </ul>
  15. Ընկերությունն ուսումնասիրում է գրավոր պահանջները (բողոքները) և դրանց գրավոր պատասխանում օրենսդրությամբ սահմանված ժամկետներում:<br /><br />
  16. Ընկերությունը պատասխանատվություն չի կրում Կայքի միջոցով երրորդ անձանց կողմից առաջարկվող և մատուցվող ծառայությունների, ապրանքների և աշխատանքների համար:
</>;

const confidentialityConditionsText = <>
  Սույն քաղաքականությունը տարածվում է բոլոր այն այցելուների, օգտատերերի և այլ անձանց վրա, ովքեր օգտվում են ineed.am կայքի (այսուհետ՝ Կայք) ծառայություններից կամ նման ծառայություններից օգտվելու իրավունք ունեն: Նպատակն է տեղեկացնել, թե կայքում գրանցվելու համար ինչ տվյալներ են հավաքագրվում, մշակվում և ինչպես են դրանք օգտագործվում: Սույն քաղաքականությունը ցանկացած ժամանակ առանց նախնական ծանուցման կարող է միակողմանի փոփոխվել: Փոփոխված տարբերակը կհրապարակվի Կայքում՝ նշելով վերջին փոփոխության ամսաթիվը: Նոր պայմաններն իրավական ուժ կունենան Կայքում տեղադրվելու պահից և կտարածվեն դրանից հետո ծագած պարտավորությունների վրա: Կայքի այցելուների, օգտատերերի պարտականությունն է ժամանակ առ ժամանակ այցելել Կայք և ծանոթանալ փոփոխություններին:<br /><br />
  1. Այցելելով Կայք, Դուք տալիս եք Ձեր համաձայնությունը Ձեր մուտքագրած անձնական տվյալները սույն քաղաքականությանը համաձայն մեր Կայքի կողմից մշակվելու եվ օգտագործվելու համար, հակառակ դեպքում Դուք իրավունք չունեք օգտվել Կայքում մատուցվող ծառայություններից:<br /><br />
  2. Անգործունակ կամ 18 տարին չլրացած անձինք (բացառությամբ օրենսդրությամբ սահմանված կարգով լրիվ գործունակ ճանաչված լինելու դեպքի) իրավունք չունեն օգտվել Կայքի կողմից մատուցվող ծառայություններից: Օգտատերերի կողմից մուտքագրվող տեղեկությունների իսկությունը ստուգելու հնարավորության բացակայության պատճառով, պատասխանատվություն չենք կրում նման անձանց կողմից Կայքից և մեր կողմից մատուցվող ծառայություններից օգտվելու հետևանքների համար եվ սույն կետի յուրաքանչյուր խախտման ամբողջական պատասխանատվությունը ընկնում է Ձեզ վրա:<br /><br />
  3. Անձնական տվյալներ եվ այլ տեղեկատվություն<br /><br />
  4. Ձեր կողմից տրամադրված տեղեկությունների օգտագործման եղանակները<br />
  <ul>
    <li>Ձեզ հետաքրքրող ծառայություններ և ապրանքներ առաջարկելու համար,</li>
    <li>Սպասարկում իրականացնելու համար,</li>
    <li>Տեխնիկական բարդությունների կամ Կայքից օգտվելու դժվարությունների դեպքում Ձեզ աջակցելու համար,</li>
    <li>Նորությունների, նոր ապրանքների կամ նոր ծառայությունների կամ հատուկ առաջարկների մասին Ձեզ տեղեկացնելու համար,</li>
    <li>Կայքը, ծառայություններն ու ապրանքները բարելավելու համար,</li>
  </ul>
  5. Անձնական տվյալների պաշտպանությունը<br /><br />
  Մենք անհրաժեշտ միջոցառումներ ենք իրականացնում Ձեր անձնական տեղեկությունների անվտանգությունն ապահովելու համար: Ձեր տրամադրած տեղեկությւոնները պահվում են ապահով սերվերների տվյալների բազայում: Ձեր անձնական տվյալները կտրամադրվեն Կայքի հետ համագործակցող Ընկերություններին, եթե դրանք անհրաժեշտ են Ձեզ մատուցվող ծառայություններն իրականացնելու և դրանց որակը բարելավելու համար (օրինակ՝ պատվերների ընդունում և պահեստավորում, առաքում, փոստային կամ էլ.փոստային նամակների ուղարկում, տվյալների բազայի վերլուծություն, մարքեթինգային ծառայությունների մատուցում, բանկային քարտերով վճարումների իրականացման կատարում, հաճախորդների սպասարկում եվ այլն): Այդ անձինք ստանում են անհրաժեշտ տվյալներին հասանելիություն իրենց կողմից նշված գործառնությունների իրականացման նպատակով և իրավունք չունեն օգտագործել նույն տեղեկատվությունը այլ նպատակներով:
  6. Գործող օրենսդրություն.<br /><br />
  Մուտք գործելով Կայք կամ Կայքից օգտվելիս Դուք ընդունում եք, որ Կայք այցելելու և օգտվելու հետ կապված բոլոր հարցերը կարգավորվում են Հայաստանի Հանրապետության օրենսդրությամբ: Վեճերի առաջացման դեպքում դրանք կարգավորվում են բանակցությունների միջոցով, համաձայնության չգալու դեպքում, վեճերը կկարգավորվեն ՀՀ օրենսդրությամբ նախատեսված կարգով:
</>;

const exchangeReturnText = <>
  <b>Պատշաճ որակի ապրանքի փոխարինում եվ վերադարձ</b><br /><br />
  Գնված ապրանքը կարելի է վերադարձնել կամ փոխարինել այլ չափի, ձևի, գույնի կամ համանման կոմպլեկտայնության ապրանքով` գնի տարբերության դեպքում անհրաժեշտ վերահաշվարկ կատարելով, ապրանքը Գնորդին հանձնելու օրվանից 14 օրվա ընթացքում, բացառությամբ ներքոնշյալ դեպքերի և կառավարության սահմանած անվանացանկով ապրանքների:<br />
  Պատշաճ որակի ոչ պարենային ապրանքը փոխարինվում կամ վերադարձվում է, եթե նշված ապրանքը չի օգտագործվել, պահպանված են դրա ապրանքատեսքը, սպառողական հատկանիշները, կապարակնիքները, ապրանքային պիտակները, ինչպես նաև սպառողին տրված վճարման փաստը հավաստող փաստաթուղթը կամ այլ հաշվարկային փաստաթուղթ, և առկա են ապրանքը հենց այդ վաճառողից ձեռք բերելու մասին ապացույցներ:<br /><br />
  <b>Պատշաճ որակի ապրանքը չի կարող վերադարձվել՝</b><br /><br />
  ա) եթե ապրանքների պատրաստումը և մատակարարումը իրականացվել են գնորդի հատուկ պահանջներին համապատասխան, կամ ապրանքները անհատականացված են,<br />
  բ) երբ մատակարարվում են ապրանքներ, որոնք ունեն արագ փչացման, քայքայման կամ որակի փոփոխության հատկություն,<br />
  գ) կապարակնքված ապրանքների վաճառքի դեպքում, որոնք վերադարձման ենթակա չեն առողջապահական կամ հիգիենիկ նկատառումներից ելնելով, և որոնք մատակարարվելուց հետո ապակապարակնքվել են գնորդի կողմից.<br />
  դ) ապրանքների վաճառքի դեպքում, որոնց մատակարարումից հետո, իրենց բնույթից ելնելով, անքակտելիորեն միախառնվում են միմյանց հետ,<br />
  ե) կապարակնքված ձայնային կամ տեսաձայնային ձայնագրության կամ կապարակնքված ծրագրային ապահովման մատակարարման դեպքում, որոնք մատակարարելուց հետո ապակապարակնքվել են գնորդի կողմից,<br />
  զ) թերթերի, ամսագրերի, գրքերի կամ այլ տպագիր նյութերի մատակարարման դեպքում,<br />
  է) աճուրդում կամ բորսայում կնքված պայմանագրերի առկայության դեպքում.<br />
  ը) թվային կրիչի վրա չմատակարարվող թվային բովանդակության մատակարարման դեպքում, երբ դրա կատարումն սկսվել է սպառողի անվերապահ նախնական համաձայնությամբ, ըստ որի` սպառողն այդպիսով կորցնում է իր վերադարձման իրավունքը,<br /><br/>
  <b>Ոչ պատշաճ որակի ապրանքի փոխարինում եվ վերադարձ</b><br /><br />
  Ոչ պատշաճ որակի ապրանքի վերաբերյալ պահանջ ստանալու դեպքում վաճառողն իրավունք ունի իրականացնելու ապրանքի որակի ստուգում, որի արդյունքները կներկայացվեն  Ձեզ: Տեխնիկապես բարդ ապրանքների նկատմամբ Գնորդի` ապրանքը վերադարձնելու, նմանօրինակ նմուշի կամ այլ նմուշի ապրանքով փոխարինելու պահանջները ենթակա են բավարարման` ապրանքում էական խախտումների հայտնաբերման դեպքում: Այդպիսի ապրանքների անվանացանկը հաստատում է կառավարությունը:<br />
  Գնորդի կողմից ոչ պատշաճ որակի ապրանքի ձեռքբերման դեպքում, որի համար սահմանված է պիտանիության ժամկետ, վաճառողը պարտավոր է այդ ապրանքը փոխարինել պատշաճ որակի ապրանքով կամ սպառողին վերադարձնել նրա վճարած գումարը, եթե ապրանքի թերությունները հայտնաբերվել են պիտանիության ժամկետի սահմաններում:<br />
  Ապրանքի փոխարինումը և վերադարձը կարգավորվում է «Սպառողների իրավունքների պաշտպանության մասին»  ՀՀ օրենքով:
</>;

const aboutTheProjectText = <>
  <p>ineed-ի թիմը ուրախ է ողջունելու Ձեզ!!!</p>
  <p>Ստեղծման պահից ի վեր մեր հիմնական նպատակն է եղել ներդնել առցանց գնումների և վաճառքների նոր մոդել՝  պահպանելով  արդեն  իսկ լայն տարածում գտած  տարբեարկները։
    ineed-ը համաշխարհային առցանց տիրույթում առաջինն է, որ ներդրել է երկու նորարական  Startup՝
  </p>
  <ul>
    <li>
    Հնարավորություն ցանցում ներկայացված լայն տեսականուց բացի մեկ հպումով  ստանալ և ստանդարտ, և հատուկ նշանակության ապրանքների գնային առաջարկներ՝ համակարգում գրանցված տեղական և արտասահմանյան մատակարարների կողմից։
    </li>
    <li>
      Գնումների ընդունված տարբերակներին ավելանում են նկարների,տեսանյութերի և ձայնային հաղորդագրությունների  միջոցով  ապրանք և ծառայություն պատվիրելու նոր հնարավորությունները։
    </li>
  </ul>

</>;

const howWeWorkText = <>
  <h3>Լրացրեք ցանկացած ապրանքի տվյալներ և ուղարկեք մեզ</h3>
  <p>Ցանկացած տառատեսակով լրացրեք Ձեզ անհրաժեշտ ապրանքի անվանումը, չափման միավորը, քանակությունը (որից կարող է կախված լինել առաջարկվող գինը), տեխնիկական կամ այլ նկարագրությունը և, սեղմելով &lt;&lt;ուղարկել&gt;&gt; կոճակը, իրականացրեք պատվերը: Անհրաժեշտության դեպքում կարող եք կցել նաև նկարներ, ֆայլեր, տեխնիկական գծագրեր և այլ փաստաթղթեր: Եթե ունեք ապրանքների պատրաստի ցանկը, որոնք նախատեսում եք պատվիրել, ապա ժամանակ չկորցնելու համար կարող եք կցել այն համապատասխան վայրում: Ապրանքի պատվիրման մեծ քանակության դեպքում հնարավոր է գնային առաջարկ եւ ապրանքի ներմուծում անմիջապես արտադրողից:</p>

  <h3>Մենք կհաշվարկենք պատվերի արժեքը 24 ժամվա ընթացքում</h3>
  <p>
    Պատվերը ստանալուց հետո մեր մասնագետները առավել արդյունավետ տարբերակ գտնելու համար կուսումնասիրեն մեծածախ շուկան և 24 ժամվա ընթացքում հետադարձ հասցեով կուղարկեն գնային առաջարկ, որը կարող եք ընդունել ամբողջությամբ կամ մասնակի: Գնումներ կարելի է կատարել<br /><br />
    Կանխիկ՝ վճարելով անմիջապես առաքիչին,<br />
    Օնլայն՝ կայքում նշված տարբերակներից որևէ մեկով,<br />
    Փոխանցումով՝ հաշիվ-ապրանքագրի հիման վրա:<br /><br />
    Գնելու դեպքում հնարավոր է ապրանքի պահեստավորում և առաքում: Մենք երաշխավորում ենք մեր կողմից առաջարկվող գների մրցունակությունը` հաշվի առնելով ձեռք բերած էքսկլյուզիվ պայմանագրերը ինչպես տեղական արտադրողների, այնպես էլ մեծածախ վաճառք իրականացնողների հետ: Պատվերի մեծ քանակության դեպքում հնարավոր է նաև արտասահմանյան շուկաների ուսումնասիրություն և ապրանքի ներմուծում: Ապրանքների ներմուծման դեպքում ineed –ի թիմը կկազմակերպի ապրանքի գնումը, ներմուծումը, մաքսազերծումը, պահեստավորումը և առաքումը:
  </p>

  <h3>Կառավարեք Ձեր գնումները անձնական էջի օգնությամբ</h3>
  <p>Կայքում անձնական էջը անհատական տարածություն է, որտեղ կարող եք ստանալ հավաստի տեղեկություններ իրականացված գործառույթների մասին: Այնտեղ մուտք գործելու համար բավական է գրանցվել կամ մուտքագրվել, որից հետո կստանաք կայքում Ձեր գործունեության մասին ամբողջական տեղեկատվություն: Դուք ստանում եք մեծ առավելություններ, քանի որ տեսնում եք Ձեր գործարքների մասին ողջ տեղեկատվությունը, ինչպես նաև հնարավորություն ունեք արագ ստանալու ineed-ի թիմի աշխատակիցների ծառայությունները և օգնությունը հետադարձ կապով:  Ընդհանուր առմամբ անձնական էջում կարող եք կատարել վճարումներ, ինչպես նաև վերլուծել նախկինում կատարված պատվերների և գնումների վիճակագրությունը: Գնումների արխիվը Ձեզ հնարավորություն կտա արագ և առանց դժվարության կրկնել այս կամ այն գործողությունը: Հիմնական առավելություններից մեկն էլ այն է, որ անձնական էջի միջոցով կարողանում եք անմիջապես կատարել Ձեզ անհրաժեշտ փոփոխությունները՝ առանց այցելելու մեր գրասենյակ:</p>

  <h3>Մենք անվտանգ կպահեստավորենք Ձեր ապրանքը</h3>
  <p>Եթե ունեք ապրանքը, սակայն այն այդ պահին չեք օգտագործելու, մենք առաջարկում ենք ապրանքի մասնակի կամ ամբողջական պահեստավորում՝ տրամադրելով ծավալուն պահեստային տարածքներ: Պահեստավորում ասելով հասկանում ենք Ձեր ապրանքի քանակի և ապահովության համար մեր պատասխանատվությունը: Պահեստավորման ընթացքում կատարում ենք պատվերի մաքսիմալ օպերատիվ ընդունում, ապրանքների կոնկրետ հաշվարկ, ինչպես նաև հնարավորություն ենք տալիս անմիջապես հետևելու պահեստավորման պայմաններին: Երաշխավորում ենք  ապրանքների ապահովությունը՝ շնորհիվ գործող տեսախցիկների և 24 ժամյա հսկողության: Հնարավորություն ենք տալիս ցանկացած պահի վերցնել Ձեր ապրանքը՝ համապատասխան վայրում հայտ լրացնելով, և մենք կկազմակերպենք ապրանքի առաքումը նշված հասցե կարճ ժամանակահատվածում:</p>

  <h3>Առաջարկում ենք ապրանքների արագ և ապահով առաքում</h3>
  <p>Ձեր կողմից ձեռք բերված, ինչպես նաեւ իպահ հանձնված ապրանքները կարող եք ստանալ անմիջապես պահեստից կամ օգտվել ineed առաքման ծառայությունից: Առաքումը կարող է կատարվել ineed պահեստից դեպի Ձեր հասցե, ցուցասրահ կամ պահեստ եւ հակառակ ուղությամբ 1 աշխատանքային օրվա ընթացքում: Մեր հաճախորդները կարող են հանդիսանալ բոլոր Ineed համակարգից օգտվողները, ինչպես ֆիզիկական անձինք, այնպես էլ իրավաբանական` փոքր, միջին եւ մեծ ձեռնարկությունները:</p>
</>;

const adventagesText = <>
  <h3>Խնայում ենք Ձեր ժամանակը, գումարը և նյարդերը</h3>
  <p>ineed- ից օգտվելը արագ է, պարզ և հարմար: Մեր օգնությամբ կարող եք բարձրացնել Ձեր գնումները նոր մակարդակի վրա: Յուրաքանչյուր մարդու համար գնումներում  ամենակարևորն են ժամանակը, դրամական միջոցները և նյարդերը: Ոչ ոք չի ուզում դրանք ծախսել ապարդյուն: Այդ նպատակով էլ ineed-ի խնդիրն է գնային առաջարկ ներկայացնելուց առաջ իրականացնել շուկայի մանրամասն ուսումնասիրություն և տրամադրել Ձեզ սպառիչ տեղեկատավություն, որի հիման վրա կարող եք կայացնել օպտիմալ որոշում` ընտրելով Ձեզ հարմար տարբերակը: Նման մոտեցումը Ձեզ հնարավորություն կտա խուսափելու անհիմն ծախսերից և անհանգստություններից:</p>

  <h3>Անվճար տրամադրում ենք շուկայական գների վերլուծություն</h3>
  <p>Արդյունավետ գնումներ իրականացնելու համար կարևորվում է ծախսերի նվազեցումը, ինչն էլ իր հերթին ենթադրում է ապրանքների ձեռք բերում մինիմալ գներով: Ineed –ը առաջարկում է շուկայական գների վերլուծության տրամադրում  անվճար: Շուկայական գների վերլուծությունը թույլ է տալիս հետևելու շուկայական գների փոփոխության դինամիկային՝ ապահովելով մեր հաճախորդների համար իրենց անհրաժեշտ ապրանքը ամենացածր գնով ձեռք բերելու հնարավորությունը: Ունենալով շուկայական գների վերլուծություն՝ ունենում եք տեղեկատվական առավելություն և ծախսերը նվազեցնելու մեծ հնարավորություններ:</p>

  <h3>Հնարավորություն ենք տալիս օգտվել լավագույն մատակարարների առաջարկներից և հատուկ պայմաններով պայմանագրերից</h3>
  <p>Մեր կողմից ձեռք բերված հատուկ պայմանները արտադրողների և մեծածախ վաճառք իրականացնողների հետ թույլ են տալիս մեր հաճախորդներին առաջարկել անհրաժեշտ ապրանքների լայն տեսականի ամենացածր գներով: Շնորհիվ մշակված  զեղչային համակարգի՝ կարող եք համոզված լինել, որ նվազեցնում եք Ձեր ծախսերը՝ գնելով ապրանքները նվազագույն գներով: Ցածր գները ձևավորվում են մատակարարների հետ  հատուկ և էքսկլյուզիվ պայմանավորվածությունների հիման վրա, ինչպես նաև շնորհիվ մեր կողմից կազմակերպված էֆեկտիվ աշխատանքի և արդյունավետ լոգիստիկայի:</p>

  <h3>Օգնում ենք ընկերություններին, ավելացնել վաճառքի ծավալները եւ ընդգրկվել նոր շուկաներում</h3>
  <p>Յուրաքանչյուր ընկերություն իր առջև նպատակ է դնում ավելացնելու վաճառքների ծավալները, ինչպես նաև ներգրավելու նոր շուկաներ: Մուտք գործելով մեր կողմից առաջարկվող մեծածախ առևտրի ցանց, Դուք հնարավորություն կունենաք ներկայացնել Ձեր ապրանքը ամբողջ Հայաստանի մեծածախ եւ մանրածախ առեվտրի կետերում՝ ինչպես սեփական անվանման տակ,այնպես ել մեր ընկերության մասնագետի կողմից առաջարվող ապրանքանիշի ներքո: Ապահովում ենք ապրանքանիշի առաջխաղացումը՝ իրականացնելով արդյունավետ եւ հաշվարկային թվերի վրա հիմնված գովազդ:</p>

  <h3>Անվտանգ պահեստավորում ենք վստահված ապրանքը</h3>
  <p>Մեր հաճախորդներին առաջարկում ենք ապրանքների անվտանգ պահպանումը՝ անվտանգության եւ նորարարական ծրագրերով կահավորված պահեստներում, ինչպես նաեւ  հատուկ տիպի ապրանքների համար նախատեսված ժամանակակից պահեստային տարածքներում: Կազմակերպում ենք օպերատիվ բեռնման եւ բեռնաթափման աշխատանքեր՝ հատուկ մասնագիտացված տեխնիկայի օգնությամբ: Այս ծառայությունը հնարավորություն է տալիս նվազեցնել ապրանքների պահեստավորման հետ կապված ծախսերը և համոզված լինել դրանց լիարժեք ապահովության մեջ:</p>

  <h3>Ապրանքի առաքումը կատարում ենք արագ և ապահով</h3>
  <p>Առաքումը իրականացնում ենք մասնագիտացված բեռնատարներով ցանկացած վայր եւ հակառակ ուղությամբ ժամը  8:30-18:00 ընկած ժամանակահատվածում: Առաջարկում ենք բեռնափոխադրման 4 " Դուռ-Դուռ,Դուռ-Պահեստ ,Պահեստ-Դուռ եւ Պահեստ-Պահեստ տարբերակները: Առաջարկում ենք առաքման  2 փաթեթ "Ստանդարտ (Առաքումը իրականացվում է 1-2 օրվա ընթացքում,կախված հեռավորությունից) եւ Արագ (առաքումը իրականացվում է 1-2 ժամվա ընթացքում կախված հեռավորությունից): Երաշխավորում ենք ապրանքների ապահով առաքումը և ապահովում ենք ճկուն գնային քաղաքականություն:</p>
</>;

const deliveryText = <>
  <h3>Առաքում</h3>
  <p>Մենք պատրաստ ենք առաջարկել մեր հաճախորդներին ժամանակակից սպասարկում եւ ծառայություն: Իրականացնում ենք ապրանքի ընդունում եւ առաքում, բեռնում եւ բեռնաթափում,փաթեթավորում: Ինչպես նաեւ առաջարկում ենք առաքման օպտիմալ տարիֆային համակարգ, համաձայն որի ստորեւ նշված գումարից ավել գնումների դեպքում առաքումը կիրականացվի անվճար, հակառակ դեպքում կհաշվարկվի ըստ սահմանված գնացուցակի: Ապրանքի առաքումը կիրականացվի Ձեր կողմից նախօրոք նշված ժամկետներում՝ արագ եւ ապահով, հատուկ բեռնափոխադրման համար նախատեսված մեքենաներով: Մենք երաշխավորում ենք ապրանքի ապահովությունը եւ անվտանգ տեղափոխումը: Ձեր սպասելիքներին չհամապտասխանության դեպքում երաշխավորում ենք ապրանքի, ինչպես նաև վճարված գումարի հետ վերադարձը հինգ աշխատանքային օրվա ընթացքում:</p>
  <h3>Անվճար առաքման համար սահմանված սանդղակ:</h3><br />

  <table className="G-simple-table-mobile">
    <tr>
      <td><strong>Առաքման հասցե</strong></td>
      <td><strong>Արժեք (դրամ)</strong></td>
    </tr>
    <tr>
      <td>Ք.Երեւան</td>
      <td>15,000</td>
    </tr>
    <tr>
      <td>Մարզեր&lt;50km</td>
      <td>250,000</td>
    </tr>
    <tr>
      <td>Մարզեր&lt;100km</td>
      <td>400,000</td>
    </tr>
    <tr>
      <td>Մարզեր&lt;200km</td>
      <td>800,000</td>
    </tr>
    <tr>
      <td>Մարզեր&lt;300km</td>
      <td>1,200,000</td>
    </tr>
  </table><br /> <br />

  <table className="G-simple-table">
    <tr>
      <td><strong>Առաքման հասցե</strong></td>
      <td><strong>Արժեք (դրամ)</strong></td>
    </tr>
    <tr>
      <td>Ք.Երեւան</td>
      <td>15,000</td>
    </tr>
    <tr>
      <td>Մարզեր&lt;50կմ</td>
      <td>250,000</td>
    </tr>
    <tr>
      <td>Մարզեր&lt;100կմ</td>
      <td>400,000</td>
    </tr>
    <tr>
      <td>Մարզեր&lt;200կմ</td>
      <td>800,000</td>
    </tr>
    <tr>
      <td>Մարզեր&lt;300կմ</td>
      <td>1,200,000</td>
    </tr>
  </table><br /> <br />
  <h3>Վճարովի առաքման համար սահմանված սանդղակ:</h3><br />

  <table className="G-simple-table-mobile">
    <tr>
      <td><strong>Քաղաք/գյուղ</strong></td>
      <td><strong>Արժեք (դրամ)</strong></td>
    </tr>
    <tr>
      <td>Երևան</td>
      <td>500</td>
    </tr>
    <tr>
      <td>Արարատ</td>
      <td>5200</td>
    </tr>
    <tr>
      <td>Պտղնի</td>
      <td>800</td>
    </tr>
    <tr>
      <td>Մեղրաձոր</td>
      <td>5200</td>
    </tr>
    <tr>
      <td>Նուբարաշեն</td>
      <td>1000</td>
    </tr>
    <tr>
      <td>Թալին</td>
      <td>5700</td>
    </tr>
    <tr>
      <td>Պռոշյան (գյուղ)</td>
      <td>1000</td>
    </tr>
    <tr>
      <td>Հանքավան</td>
      <td>6300</td>
    </tr>
    <tr>
      <td>Աբովյան</td>
      <td>1100</td>
    </tr>
    <tr>
      <td>Ջրաշեն</td>
      <td>6800</td>
    </tr>
    <tr>
      <td>Զվարթնոց</td>
      <td>1100</td>
    </tr>
    <tr>
      <td>Գավառ</td>
      <td>7600</td>
    </tr>
    <tr>
      <td>Ձորաղբյուր</td>
      <td>1100</td>
    </tr>
    <tr>
      <td>Դիլիջան</td>
      <td>7700</td>
    </tr>
    <tr>
      <td>Արամուս</td>
      <td>1300</td>
    </tr>
    <tr>
      <td>Սպիտակ</td>
      <td>7900</td>
    </tr>
    <tr>
      <td>Արզնի</td>
      <td>1300</td>
    </tr>
    <tr>
      <td>Արթիկ</td>
      <td>8200</td>
    </tr>
    <tr>
      <td>Եղվարդ</td>
      <td>1300</td>
    </tr>
    <tr>
    <td>Մարալիկ</td>
      <td>8200</td>
    </tr>
    <tr>
      <td>Էջմիածին</td>
      <td>1300</td>
    </tr>
    <tr>
      <td>Արենի</td>
      <td>8700</td>
    </tr>
    <tr>
      <td>Մասիս</td>
      <td>1300</td>
    </tr>
    <tr>
      <td>Ազատան</td>
      <td>8900</td>
    </tr>
    <tr>
      <td>Նոր Հաճն</td>
      <td>1300</td>
    </tr>
    <tr>
    <td>Շիրակավան</td>
      <td>9100</td>
    </tr>
    <tr>
      <td>Բյուրեղավան</td>
      <td>1500</td>
    </tr>
    <tr>
    <td>Եղեգնաձոր</td>
      <td>9600</td>
    </tr>
    <tr>
      <td>Կաթնաղբյուր, Կոտայք</td>
      <td>1500</td>
    </tr>
    <tr>
    <td>Խնձորեսկ</td>
      <td>9600</td>
    </tr>
    <tr>
      <td>Աշտարակ</td>
      <td>1600</td>
    </tr>
    <tr>
    <td>Ճամբարակ</td>
      <td>9800</td>
    </tr>
    <tr>
      <td>Նոր Գեղի</td>
      <td>1600</td>
    </tr>
    <tr>
    <td>Վանաձոր</td>
      <td>9800</td>
    </tr>
    <tr>
      <td>Մուղնի, Աշտարակ</td>
      <td>1700</td>
    </tr>
    <tr>
    <td>Ախուրյան</td>
      <td>9900</td>
    </tr>
    <tr>
      <td>Լուսակերտ</td>
      <td>1800</td>
    </tr>
    <tr>
    <td>Գյումրի</td>
      <td>9900</td>
    </tr>
    <tr>
      <td>Գառնի</td>
      <td>2000</td>
    </tr>
    <tr>
    <td>Մարտունի</td>
      <td>10100</td>
    </tr>
    <tr>
      <td>Օշական</td>
      <td>2000</td>
    </tr>
    <tr>
    <td>Վայք</td>
      <td>10900</td>
    </tr>
    <tr>
      <td>Ազատավան</td>
      <td>2100</td>
    </tr>
    <tr>
    <td>Իջևան</td>
      <td>11200</td>
    </tr>
    <tr>
      <td>Արտաշատ</td>
      <td>2100</td>
    </tr>
    <tr>
    <td>Ամասիա</td>
      <td>11600</td>
    </tr>
    <tr>
      <td>Փարպի, Արագածոտն</td>
      <td>2100</td>
    </tr>
    <tr>
    <td>Մեղրուտ</td>
      <td>11700</td>
    </tr>
    <tr>
      <td>Գեղարդ</td>
      <td>2300</td>
    </tr>
    <tr>
    <td>Ստեփանավան</td>
      <td>12300</td>
    </tr>
    <tr>
      <td>Չարենցավան</td>
      <td>2600</td>
    </tr>
    <tr>
    <td>Աշոցք</td>
      <td>13000</td>
    </tr>
    <tr>
      <td>Բյուրական</td>
      <td>2700</td>
    </tr>
    <tr>
    <td>Վարդենիս</td>
      <td>13200</td>
    </tr>
    <tr>
      <td>Ուջան</td>
      <td>2700</td>
    </tr>
    <tr>
    <td>Տաշիր</td>
      <td>13700</td>
    </tr>
    <tr>
      <td>Մեծամոր</td>
      <td>2800</td>
    </tr>
    <tr>
    <td>Ջերմուկ</td>
      <td>14000</td>
    </tr>
    <tr>
      <td>Արզական</td>
      <td>3100</td>
    </tr>
    <tr>
    <td>Ալավերդի</td>
      <td>15100</td>
    </tr>
    <tr>
      <td>Կոշ&nbsp;&nbsp;&nbsp; </td>
      <td>3200</td>
    </tr>
    <tr>
    <td>Նոյեմբերյան</td>
      <td>15100</td>
    </tr>
    <tr>
      <td>Բջնի</td>
      <td>3300</td>
    </tr>
    <tr>
    <td>Բերդ</td>
      <td>16700</td>
    </tr>
    <tr>
      <td>Արագած</td>
      <td>3400</td>
    </tr>
    <tr>
    <td>Սիսիան</td>
      <td>17100</td>
    </tr>
    <tr>
      <td>Արալեզ</td>
      <td>3400</td>
    </tr>
    <tr>
    <td>Գորիս</td>
      <td>19700</td>
    </tr>
    <tr>
      <td>Արմավիր</td>
      <td>3600</td>
    </tr>
    <tr>
    <td>Քարվաճառ</td>
      <td>20000</td>
    </tr>
    <tr>
      <td>Աղվերան </td>
      <td>3700</td>
    </tr>
    <tr>
    <td>Շուշի</td>
      <td>24500</td>
    </tr>
    <tr>
      <td>Հրազդան</td>
      <td>3700</td>
    </tr>
    <tr>
    <td>Կապան</td>
      <td>25300</td>
    </tr>
    <tr>
      <td>Վեդի</td>
      <td>3700</td>
    </tr>
    <tr>
    <td>Քաջարան</td>
      <td>25900</td>
    </tr>
    <tr>
      <td>Ավշար</td>
      <td>3900</td>
    </tr>
    <tr>
    <td>Ստեփանակերտ</td>
      <td>26100</td>
    </tr>
    <tr>
      <td>Ապարան </td>
      <td>4500</td>
    </tr>
    <tr>
    <td>Ասկերան</td>
      <td>29300</td>
    </tr>
    <tr>
      <td>Ծաղկաձոր</td>
      <td>4900</td>
    </tr>
    <tr>
    <td>Մարտունի</td>
      <td>30500</td>
    </tr>
    <tr>
      <td>Կաթնաղբյուր, Արագածոտն</td>
      <td>4900</td>
    </tr>
    <tr>
    <td>Մեղրի</td>
      <td>31300</td>
    </tr>
    <tr>
      <td>Մելիքգյուղ,&nbsp; Արագածոտն</td>
      <td>5000</td>
    </tr>
    <tr>
    <td>Մարտակերտ</td>
      <td>32500</td>
    </tr>
    <tr>
      <td>Սևան</td>
      <td>5100</td>
    </tr>
    <tr>
    <td>Հադրութ</td>
      <td>34900</td>
    </tr>
  </table>


  <table className="G-simple-table">
    <tr>
      <td><strong>Քաղաք/գյուղ</strong></td>
      <td><strong>Արժեք (դրամ)</strong></td>
      <td><strong>Քաղաք/գյուղ</strong></td>
      <td><strong>Արժեք (դրամ)</strong></td>
    </tr>
    <tr>
      <td>Երևան</td>
      <td>500</td>
      <td>Արարատ</td>
      <td>5200</td>
    </tr>
    <tr>
      <td>Պտղնի</td>
      <td>800</td>
      <td>Մեղրաձոր</td>
      <td>5200</td>
    </tr>
    <tr>
      <td>Նուբարաշեն</td>
      <td>1000</td>
      <td>Թալին</td>
      <td>5700</td>
    </tr>
    <tr>
      <td>Պռոշյան (գյուղ)</td>
      <td>1000</td>
      <td>Հանքավան</td>
      <td>6300</td>
    </tr>
    <tr>
      <td>Աբովյան</td>
      <td>1100</td>
      <td>Ջրաշեն</td>
      <td>6800</td>
    </tr>
    <tr>
      <td>Զվարթնոց</td>
      <td>1100</td>
      <td>Գավառ</td>
      <td>7600</td>
    </tr>
    <tr>
      <td>Ձորաղբյուր</td>
      <td>1100</td>
      <td>Դիլիջան</td>
      <td>7700</td>
    </tr>
    <tr>
      <td>Արամուս</td>
      <td>1300</td>
      <td>Սպիտակ</td>
      <td>7900</td>
    </tr>
    <tr>
      <td>Արզնի</td>
      <td>1300</td>
      <td>Արթիկ</td>
      <td>8200</td>
    </tr>
    <tr>
      <td>Եղվարդ</td>
      <td>1300</td>
      <td>Մարալիկ</td>
      <td>8200</td>
    </tr>
    <tr>
      <td>Էջմիածին</td>
      <td>1300</td>
      <td>Արենի</td>
      <td>8700</td>
    </tr>
    <tr>
      <td>Մասիս</td>
      <td>1300</td>
      <td>Ազատան</td>
      <td>8900</td>
    </tr>
    <tr>
      <td>Նոր Հաճն</td>
      <td>1300</td>
      <td>Շիրակավան</td>
      <td>9100</td>
    </tr>
    <tr>
      <td>Բյուրեղավան</td>
      <td>1500</td>
      <td>Եղեգնաձոր</td>
      <td>9600</td>
    </tr>
    <tr>
      <td>Կաթնաղբյուր, Կոտայք</td>
      <td>1500</td>
      <td>Խնձորեսկ</td>
      <td>9600</td>
    </tr>
    <tr>
      <td>Աշտարակ</td>
      <td>1600</td>
      <td>Ճամբարակ</td>
      <td>9800</td>
    </tr>
    <tr>
      <td>Նոր Գեղի</td>
      <td>1600</td>
      <td>Վանաձոր</td>
      <td>9800</td>
    </tr>
    <tr>
      <td>Մուղնի, Աշտարակ</td>
      <td>1700</td>
      <td>Ախուրյան</td>
      <td>9900</td>
    </tr>
    <tr>
      <td>Լուսակերտ</td>
      <td>1800</td>
      <td>Գյումրի</td>
      <td>9900</td>
    </tr>
    <tr>
      <td>Գառնի</td>
      <td>2000</td>
      <td>Մարտունի</td>
      <td>10100</td>
    </tr>
    <tr>
      <td>Օշական</td>
      <td>2000</td>
      <td>Վայք</td>
      <td>10900</td>
    </tr>
    <tr>
      <td>Ազատավան</td>
      <td>2100</td>
      <td>Իջևան</td>
      <td>11200</td>
    </tr>
    <tr>
      <td>Արտաշատ</td>
      <td>2100</td>
      <td>Ամասիա</td>
      <td>11600</td>
    </tr>
    <tr>
      <td>Փարպի, Արագածոտն</td>
      <td>2100</td>
      <td>Մեղրուտ</td>
      <td>11700</td>
    </tr>
    <tr>
      <td>Գեղարդ</td>
      <td>2300</td>
      <td>Ստեփանավան</td>
      <td>12300</td>
    </tr>
    <tr>
      <td>Չարենցավան</td>
      <td>2600</td>
      <td>Աշոցք</td>
      <td>13000</td>
    </tr>
    <tr>
      <td>Բյուրական</td>
      <td>2700</td>
      <td>Վարդենիս</td>
      <td>13200</td>
    </tr>
    <tr>
      <td>Ուջան</td>
      <td>2700</td>
      <td>Տաշիր</td>
      <td>13700</td>
    </tr>
    <tr>
      <td>Մեծամոր</td>
      <td>2800</td>
      <td>Ջերմուկ</td>
      <td>14000</td>
    </tr>
    <tr>
      <td>Արզական</td>
      <td>3100</td>
      <td>Ալավերդի</td>
      <td>15100</td>
    </tr>
    <tr>
      <td>Կոշ</td>
      <td>3200</td>
      <td>Նոյեմբերյան</td>
      <td>15100</td>
    </tr>
    <tr>
      <td>Բջնի</td>
      <td>3300</td>
      <td>Բերդ</td>
      <td>16700</td>
    </tr>
    <tr>
      <td>Արագած</td>
      <td>3400</td>
      <td>Սիսիան</td>
      <td>17100</td>
    </tr>
    <tr>
      <td>Արալեզ</td>
      <td>3400</td>
      <td>Գորիս</td>
      <td>19700</td>
    </tr>
    <tr>
      <td>Արմավիր</td>
      <td>3600</td>
      <td>Քարվաճառ</td>
      <td>20000</td>
    </tr>
    <tr>
      <td>Աղվերան</td>
      <td>3700</td>
      <td>Շուշի</td>
      <td>24500</td>
    </tr>
    <tr>
      <td>Հրազդան</td>
      <td>3700</td>
      <td>Կապան</td>
      <td>25300</td>
    </tr>
    <tr>
      <td>Վեդի</td>
      <td>3700</td>
      <td>Քաջարան</td>
      <td>25900</td>
    </tr>
    <tr>
      <td>Ավշար</td>
      <td>3900</td>
      <td>Ստեփանակերտ</td>
      <td>26100</td>
    </tr>
    <tr>
      <td>Ապարան&nbsp;</td>
      <td>4500</td>
      <td>Ասկերան</td>
      <td>29300</td>
    </tr>
    <tr>
      <td>Ծաղկաձոր</td>
      <td>4900</td>
      <td>Մարտունի</td>
      <td>30500</td>
    </tr>
    <tr>
      <td>Կաթնաղբյուր, Արագածոտն</td>
      <td>4900</td>
      <td>Մեղրի</td>
      <td>31300</td>
    </tr>
    <tr>
      <td>Մելիքգյուղ, Արագածոտն</td>
      <td>5000</td>
      <td>Մարտակերտ</td>
      <td>32500</td>
    </tr>
    <tr>
      <td>Սևան</td>
      <td>5100</td>
      <td>Հադրութ</td>
      <td>34900</td>
    </tr>
  </table>
</>;

const PrivacyPolicyText=<>
  <p><strong><span
      style={{fontSize:"19px",color:"#ED7D31"}}>&laquo;Ալֆա-Ֆարմ&raquo; &nbsp;հավելված</span></strong><strong><span
      style={{fontSize:"19px",color:"#ED7D31"}}>ի գ</span></strong><strong><span
      style={{fontSize:"19px",color:"#ED7D31"}}>աղտնիության քաղաքականություն&nbsp;</span></strong>
  </p>
  <br/>
  <p ><span >&laquo;Ալֆա-Ֆարմ&raquo; հավելվածը /այսուհետ` Հավելված/, թույլ է տալիս իր օգտատերերին օգտվել &laquo;Ալֆա-Ֆարմ&raquo; ՓԲԸ-ի ծառայություններից բջջային հեռախոսների և պլանշետային համակարգիչների միջոցով: &nbsp;Ձեր գաղտնիությունն ապահովելը կարևոր է մեր համար: &nbsp;Սույն հավելվածի սկզբունքն է հարգել ձեր &nbsp;գաղտնիությունը մեր հավելվածի &nbsp;շրջանակում առկա ցանկացած տեղեկատվության վերաբերյալ:</span>
  </p>
  <p ><span >Մենք խնդրում ենք ձեզնից անձնական տեղեկատվություն միայն այն ժամանակ, երբ իսկապես դրա կարիքն ունենք ձեզ ծառայություն մատուցելու համար: Մենք այդ տեղեկատվությունը ձեռք ենք բերում արդար և&nbsp;</span><span
      >օրինական</span><span >&nbsp;</span><span
      >միջոցներով` ձեր իմացությամբ և համաձայնությամբ: Մենք նաև տեղեկացնում ենք ձեզ, թե ինչու ենք այդ տեղեկատվությունը հավաքում և ինչպես է դա օգտագործվելու: &nbsp;Մենք պահպանում ենք հավաքված տեղեկատվությունն այնքան ժամանակ, ինչքան պահանջվում է ձեր&nbsp;</span><span
      >կողմից&nbsp;</span><span >խնդրարկված ծառայությ</span><span
      >ունը</span><span >&nbsp;</span><span
      >մատուց</span><span >ելու</span><span
      >&nbsp;</span><span >համար: Մենք չենք օգտագործի կամ հանրայնացնի անձնական նշանակություն ունեցող ցանկացած տեղեկատվություն կամ&nbsp;</span><span
      >փոխանցի</span><span >&nbsp;</span><span
      >երրորդ անձանց,</span><span >&nbsp;</span><span
      >բացառությամբ սույն Գաղտնիության Քաղաքականության մեջ նկարագրված կամ օրենքով&nbsp;</span><span
      >նախատեսված</span><span
      >&nbsp;</span><span >դեպքերի:</span></p>
  <br/>
  <br/>
  <p><strong><span
      style={{color:"#70AD47"}}>Մեր կողմից հավաքագրվող և կիրառվող տեղեկատվությունը</span></strong>
  </p>
  <br/>
  <p ><span >Մեր հավելվածն օգտագործելիս մենք կարող է հետևյալ անձնական և ոչ անձնական տեղեկատվության կարիք</span><span
      >ն</span><span >&nbsp;</span><span
      >ունենանք, որպեսզի ավելի լավ աշխատանք ապահովենք:</span></p>
  <ul  >
    <li ><strong><span
        >Գտնվելու վայրը`&nbsp;</span></strong><span
        >Քարտեզի էջերում Հավելվածը պահանջում է Ձեր գտնվելու վայրը /ոչ անձնականացված աշխարհագրական կոորդինատներ/. Կոորդինատներն անհրաժեշտ են քարտեզի կենտրոնում Ձեր գտնվելու վայրը սահմանելու համար: Ձեր կոորդինատները կվերանան Հավելվածը փակելուց հետո: Եթե Ձեր սարքավորումը Անդրոիդ տարբերակի վեցն է և ավելի</span><span
        >՝</span><span
        >&nbsp; դուք կարող եք հրաժարվել գտնվելու վայրի թույլտվություն տալուց` հասկանալով &nbsp;որ վերը նշված &nbsp;գործառույթները չեն աշխատելու: &nbsp;Եթե Ձեր սարքավորումը Անդրոիդ վեցից ցածր է, և Դուք համաձայն չեք տրամադրելու Ձեր գտնվելու վայրը, ապա խորհուրդ չենք տալիս օգտագործել հավելվածը:</span>
    </li>
    <li ><strong><span
        >Գուգլի &nbsp;ՖՍՄ /FCM/ &nbsp;նշանը (</span></strong><strong><span
        >token</span></strong><strong><span
        >)</span></strong><span >` Գուգլի Ֆայրբեյսի կողմից տրամադրված նշան է և կիրառվում է փուշ /push/ -ծանուցումներ ուղարկելու համար: Մենք վերցնում ենք &nbsp;Ձեր ՖՍՄ /FCM/ &nbsp;նշանը, ուղարկում ենք մեր սերվերին, և պահպանում այն այնտեղ հետագայում կիրառելու համար: Մենք կիրառում ենք ձեր նշանը (</span><span
        >token</span><span
        >) &nbsp;ձ</span><span >եզ</span><span
        >&nbsp;փուշ /push/ -ծանուցումներ ուղարկելու համար:&nbsp;</span><span
        >Մենք</span><span >&nbsp;</span><span
        >չենք</span><span
        >&nbsp;տրամադրի ձ</span><span >եր</span><span
        >&nbsp;նշանը (</span><span >token</span><span
        >) &nbsp;</span><span
        >երրորդ</span><span >&nbsp;</span><span
        >անձանց</span><span >:</span></li>
    <li ><strong><span
        >Անունը</span></strong><strong><span
        >,&nbsp;</span></strong><strong><span
        >ազգանունը</span></strong><strong><span
        >,&nbsp;</span></strong><strong><span
        >սեռը</span></strong><strong><span
        >,&nbsp;</span></strong><strong><span
        >ծննդյան</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >ամսաթիվը</span></strong><strong><span
        >,&nbsp;</span></strong><strong><span
        >հեռախոսահամարը</span></strong><strong><span
        >,&nbsp;</span></strong><strong><span
        >էլեկտրոնային</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >հասցեն</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >և</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >հավելվածի</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >գաղտնաբառը</span></strong><span
        >- &nbsp;</span><span
        >Գրանցման</span><span
        >&nbsp;</span><span >էջում</span><span
        >&nbsp;</span><span
        >հավելվածը</span><span
        >&nbsp; ձ</span><span
        >եզանից</span><span >&nbsp;</span><span
        >պահանջում</span><span
        >&nbsp;</span><span >է</span><span
        >&nbsp;</span><span >լրացնել</span><span
        >&nbsp;</span><span
        >տվյալները</span><span
        >:&nbsp;</span><span >Մենք</span><span
        >&nbsp;</span><span
        >հավաքագրում</span><span
        >&nbsp;</span><span >ենք</span><span
        >&nbsp;</span><span
        >տվյալները</span><span
        >,&nbsp;</span><span
        >ուղարկում</span><span
        >&nbsp;</span><span >մեր</span><span
        >&nbsp;</span><span
        >սերվերին</span><span
        >&nbsp;</span><span >և</span><span
        >&nbsp;</span><span
        >պահպանում</span><span
        >&nbsp;</span><span >այնտեղ</span><span
        >&nbsp;</span><span >հետագա</span><span
        >&nbsp;</span><span
        >կիրառման</span><span
        >&nbsp;</span><span >համար</span><span
        >:&nbsp;</span><span
        >Մենք</span><span >&nbsp;</span><span
        >այդ</span><span >&nbsp;</span><span
        >տվյալների</span><span
        >&nbsp;</span><span >կարիքն</span><span
        >&nbsp;</span><span >ունենք</span><span
        >,&nbsp;</span><span
        >որպեսզի</span><span >&nbsp;</span><span
        >կարողանանք</span><span
        >&nbsp;</span><span >ճանաչել</span><span
        >&nbsp;ձ</span><span >եզ</span><span
        >&nbsp;</span><span >և</span><span
        >&nbsp;</span><span
        >ապահովել</span><span
        >&nbsp;ձ</span><span >եր</span><span
        >&nbsp;</span><span >մուտքը</span><span
        >&nbsp;</span><span
        >Հավելվածի</span><span
        >&nbsp;</span><span
        >անհատական</span><span
        >&nbsp;</span><span
        >ծառայություներ</span><span
        >&nbsp;</span><span >և</span><span
        >&nbsp;</span><span
        >կարողանալ</span><span
        >&nbsp;</span><span >հաղորդակցվել</span><span
        >&nbsp;ձ</span><span >եր</span><span
        >&nbsp;</span><span >հետ</span><span
        >:</span></li>
    <li ><strong><span
        >Ապրանքներն</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >օնլայն</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >պատվիրելու</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >տվյալներ</span></strong><strong><span
        >,&nbsp;</span></strong><strong><span
        >ներառյալ</span></strong><strong><span
        >`&nbsp;</span></strong><strong><span
        >առաքման</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >հասցեն</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >և</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >այլ</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >տեղեկատվություն</span></strong><span
        >-&nbsp;</span><span >Մենք</span><span
        >&nbsp;</span><span >այդ</span><span
        >&nbsp;</span><span
        >տվյալների</span><span
        >&nbsp;</span><span >կարիքն</span><span
        >&nbsp;</span><span >ունենք</span><span
        >,&nbsp;</span><span
        >որպեսզի</span><span >&nbsp;</span><span
        >կարողանանք</span><span
        >&nbsp;</span><span >առաքել</span><span
        >&nbsp;</span><span
        >Հավելվածի</span><span
        >&nbsp;</span><span >միջոցով</span><span
        >&nbsp;ձ</span><span >եր</span><span
        >&nbsp;</span><span
        >պատվիրած</span><span
        >&nbsp;</span><span
        >ապրանքները</span><span >:</span></li>
    <li ><strong><span >Խնայողությունների</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >քարտի</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >համարը</span></strong><strong><span
        >,&nbsp;</span></strong><strong><span
        >մնացորդը</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >և</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >պատմությունը</span></strong><span
        >-&nbsp;</span><span >Բոլոր</span><span
        >&nbsp;</span><span
        >գրանցված</span><span
        >&nbsp;</span><span
        >օգտատերերին</span><span
        >&nbsp;</span><span >տրվում</span><span
        >&nbsp;է&nbsp;</span><span
        >անձնական</span><span
        >&nbsp;&nbsp;</span><span
        >խնայողությունների</span><span
        >&nbsp;&nbsp;</span><span
        >քարտ</span><span >:&nbsp;</span><span
        >Մեզ</span><span >&nbsp;</span><span
        >անհրաժեշտ</span><span
        >&nbsp;</span><span >են</span><span
        >&nbsp;</span><span >Ձեր</span><span
        >&nbsp;</span><span
        >տվյալները</span><span
        >,&nbsp;</span><span
        >որպեսզի</span><span >&nbsp;</span><span
        >կարողանանք</span><span
        >&nbsp;</span><span
        >ապահովել</span><span
        >&nbsp;ձ</span><span >եզ</span><span
        >&nbsp;&nbsp;</span><span
        >բոնուսներ</span><span
        >&nbsp;</span><span
        >հավաքելու</span><span
        >&nbsp;</span><span >և</span><span
        >&nbsp;</span><span >գնումն</span><span
        >ե</span><span >ր</span><span
        >ի&nbsp;</span><span
        >ժամանակ</span><span >&nbsp;</span><span
        >դրանք</span><span >&nbsp;</span><span
        >ծախսելու</span><span
        >&nbsp;</span><span
        >հնարավորությամբ</span><span >:</span>
    </li>
  </ul>
  <br/>
  <p><strong><span style={{color:"#70AD47"}}>Երրորդ</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>անձանց</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>կողմից</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>իրականացվող</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>ծառայությունների</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>համար</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>հավաքագրված</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>և</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>կի</span></strong><strong><span
      style={{color:"#70AD47"}}>ր</span></strong><strong><span
      style={{color:"#70AD47"}}>առվող</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>տեղեկատվությունը</span></strong><strong><span
      style={{color:"#70AD47"}}>.</span></strong></p>
  <br/>
  <p ><span >Հավելվածը</span><span
      >&nbsp;</span><span >կիրառում</span><span
      >&nbsp;</span><span >է</span><span
      >&nbsp;</span><span >երրորդ</span><span
      >&nbsp;</span><span >անձանց</span><span
      >&nbsp;</span><span >կողմից</span><span
      >&nbsp;</span><span
      >իրականացվող</span><span
      >&nbsp;</span><span
      >ծառայություններ</span><span
      >,&nbsp;</span><span >որ</span><span
      >ոնք &nbsp;</span><span >կարող</span><span
      >&nbsp;են&nbsp;</span><span
      >հավաքագրել</span><span
      >&nbsp;կիրառվող&nbsp;</span><span
      >տեղեկատվությու</span><span
      >նը ձ</span><span >եզ</span><span
      >&nbsp;</span><span >ճանաչելու</span><span
      >&nbsp;</span><span >համար</span><span
      >: &nbsp;&nbsp;</span><span
      >Նրանք</span><span >&nbsp;</span><span
      >կարող</span><span >&nbsp;</span><span
      >են</span><span >&nbsp; &nbsp;</span><span
      >հավաքագրել</span><span
      >&nbsp;</span><span >բազայում</span><span
      >&nbsp;</span><span >կամ</span><span
      >&nbsp;</span><span >Ձեզնից</span><span
      >&nbsp;</span><span >խնդրել</span><span
      >&nbsp;</span><span >որոշակի</span><span
      >&nbsp;</span><span >անձնական</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span >ոչ</span><span
      >&nbsp;</span><span >անձնական</span><span
      >&nbsp;</span><span >տեղեկատություն</span><span
      >,&nbsp;</span><span >ներառյալ</span><span
      >,&nbsp;</span><span >բայց</span><span
      >&nbsp;</span><span
      >չսահմանափակվելով</span><span
      >`&nbsp;</span><span >Անդրոիդի</span><span
      >&nbsp;</span><span >Գովազդի</span><span
      >&nbsp;</span><span >ԱՅԴԻ</span><span
      >-</span><span >ով</span><span
      >&nbsp;(</span><span >ID</span><span
      >)&nbsp;</span><span
      >Advertising</span><span
      >&nbsp;</span><span
      >Identifier</span><span
      >&nbsp;</span><span >for</span><span
      >&nbsp;</span><span >IOS</span><span
      >, &nbsp;</span><span >քուկիս</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span >նմանատիպ</span><span
      >&nbsp;</span><span
      >տեխնոլոգիաներ</span><span >,&nbsp;</span><span
      >Ձեր</span><span >&nbsp;</span><span
      >սարքավորման</span><span
      >&nbsp;</span><span >գտնվելու</span><span
      >&nbsp;</span><span >վայրը</span><span
      >,&nbsp;</span><span
      >Համացանցի</span><span >&nbsp;</span><span
      >արձանագրությունը</span><span
      >&nbsp;/</span><span >ԱՅՓԻ</span><span
      >/,&nbsp;</span><span >հասցեն</span><span
      >,&nbsp;</span><span
      >սարքավորման</span><span
      >&nbsp;</span><span >անունը</span><span
      >,&nbsp;</span><span >օպերատիվ</span><span
      >&nbsp;</span><span >համակարգի</span><span
      >&nbsp;</span><span >տարբերակը</span><span
      >,&nbsp;</span><span
      >Հավելվածի</span><span >&nbsp;</span><span
      >կոնֆիգուրացիան</span><span
      >,&nbsp;</span><span
      >Հավելվածի</span><span >&nbsp;</span><span
      >կիրառման</span><span >&nbsp;</span><span
      >ժամանակն</span><span >&nbsp;</span><span
      >ու</span><span >&nbsp;</span><span
      >ամսաթիվը</span><span >&nbsp;</span><span
      >և</span><span >&nbsp;</span><span
      >այլ</span><span >&nbsp;</span><span
      >վիճակագրություն</span><span
      >: &nbsp;&nbsp;</span><span
      >Հետևաբար</span><span >`&nbsp;</span><span
      >մենք</span><span >&nbsp;</span><span
      >խորհուրդ</span><span >&nbsp;</span><span
      >ենք</span><span >&nbsp;</span><span
      >տալիս</span><span >&nbsp;</span><span
      >աչքի</span><span >&nbsp;</span><span
      >անցկացնել</span><span >&nbsp;</span><span
      >այս</span><span >&nbsp;</span><span
      >ծառայությունների</span><span
      >&nbsp;</span><span
      >գաղտնիության</span><span
      >&nbsp;</span><span
      >քաղաքականությունը</span><span
      >:&nbsp;</span><span >Մենք</span><span
      >&nbsp;</span><span >չենք</span><span
      >&nbsp;</span><span
      >վերահսկում</span><span
      >&nbsp;</span><span >երրորդ</span><span
      >&nbsp;</span><span >անձանց</span><span
      >&nbsp;</span><span >կողմից</span><span
      >&nbsp;</span><span
      >իրականացվող</span><span
      >&nbsp;</span><span
      >ծառայությունների</span><span
      >&nbsp;</span><span >համար</span><span
      >&nbsp;</span><span
      >հավաքագրվող</span><span
      >,&nbsp;</span><span >կիրառվող</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span >պահպանվող</span><span
      >&nbsp;</span><span
      >տեղեկատվությունը</span><span
      >:&nbsp;</span><span >Այսպիսով</span><span
      >,&nbsp;</span><span >մենք</span><span
      >&nbsp;</span><span >ոչ</span><span
      >&nbsp;</span><span >մի</span><span
      >&nbsp;</span><span
      >պատասխանատվություն</span><span
      >&nbsp;</span><span >չենք</span><span
      >&nbsp;</span><span >կրում</span><span
      >&nbsp;</span><span >երրորդ</span><span
      >&nbsp;</span><span >անձանց</span><span
      >&nbsp;</span><span >կողմից</span><span
      >&nbsp;</span><span
      >իրականացվող</span><span
      >&nbsp;</span><span
      >ծառայությունների</span><span
      >&nbsp;</span><span >համար</span><span
      >:&nbsp;</span><span
      >Հավելվածի</span><span >&nbsp;</span><span
      >միջոցով</span><span >&nbsp;</span><span
      >կիրառվող</span><span >&nbsp;</span><span
      >երրորդ</span><span >&nbsp;</span><span
      >անձանց</span><span >&nbsp;</span><span
      >կողմից</span><span >&nbsp;</span><span
      >իրականացվող</span><span
      >&nbsp;</span><span
      >ծառայությունների</span><span
      >&nbsp;</span><span >ցանկը</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span
      >ծառայությունների</span><span
      >&nbsp;</span><span
      >գաղտնիության</span><span
      >&nbsp;</span><span
      >քաղաքականության</span><span
      >&nbsp; &nbsp;</span><span
      >կապը</span><span >`</span></p>
  <ul  >
    <li ><strong><span
        >Գուգլ քարտեզների ԷյՓիԱյ</span></strong><span
        >&nbsp;-/</span><span
        >Google</span><span >&nbsp;</span><span
        >Maps</span><span >&nbsp;</span><span
        >API</span><span >/-կիրառվում է Գուգլ քարտեզը ցույց տալու համար</span>
    </li>
    <li ><strong><span
        >Գուգլ Ֆայրբեյս</span></strong><span
        >&nbsp;/</span><span >Google</span><span
        >&nbsp;</span><span
        >Firebase</span><span >/-կիրառվում է ոչ անձնական անալիտիկ տվյալներ, հավաքագրելու համար, հավելվածի ձախողման և սխալների համար, և փուշ /</span><span
        >push</span><span >/ -ծանուցումներ ուղարկելու համար:&nbsp;</span>
    </li>
  </ul>
  <p ><span >Բոլոր վերը նշված ծառայությունները ապահովվում են Գուգլի կողմից և դու կարող ես ծառայությունների &nbsp;գաղտնիության քաղաքականությունը գտնել&nbsp;</span><span
      >Google</span><span >&nbsp;</span><span
      >Privacy</span><span >&nbsp;</span><span
      >Policy</span><span >-</span><span
      >ում</span><span >:&nbsp;</span><span
      >Քանի</span><span >&nbsp;</span><span
      >որ</span><span >&nbsp;</span><span
      >Հավելվածը</span><span >&nbsp;</span><span
      >կիրառում</span><span >&nbsp;</span><span
      >է</span><span >&nbsp;</span><span
      >Google</span><span >&nbsp;</span><span
      >Maps</span><span >&nbsp;</span><span
      >API</span><span >-ը, կիրառելով սույն Հավելվածը, Դուք նույնպես կապված եք լինելու &nbsp;Գուգլի ծառայությունների հետ /</span><span
      >Google</span><span >&nbsp;</span><span
      >Terms</span><span >&nbsp;</span><span
      >of</span><span >&nbsp;</span><span
      >Service</span><span >/,&nbsp;</span><span
      >և</span><span >&nbsp;</span><span
      >Գուգլի</span><span >&nbsp;</span><span
      >կողմից</span><span >&nbsp;</span><span
      >կիրառվող</span><span >&nbsp;</span><span
      >ցանկացած</span><span >&nbsp;</span><span
      >այլ</span><span >&nbsp;</span><span
      >պայմանների</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span
      >քաղաքականությ</span><span >ա</span><span
      >ն</span><span >:&nbsp;</span><span
      >Եթե</span><span >&nbsp;</span><span
      >Դուք</span><span >&nbsp;</span><span
      >համաձայն</span><span >&nbsp;</span><span
      >չեք</span><span >&nbsp;</span><span
      >պայմանների</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span
      >քաղաքականության</span><span
      >&nbsp;</span><span >հետ</span><span
      >,&nbsp;</span><span >խորհուրդ</span><span
      >&nbsp;</span><span >չենք</span><span
      >&nbsp;</span><span >տալիս</span><span
      >&nbsp;</span><span >կիրառել</span><span
      >&nbsp;</span><span >Հավելվածը</span><span
      >:</span></p>
  <ul  >
    <li ><strong><span >ArCa</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >API</span></strong><span >-կիրառվում է պատվերների դիմաց բանկային քարտերի միջոցով վճարումներ կատարելու &nbsp;համար: &nbsp;Եթե Դուք ցանկանում եք վճարել ձեր բանկային քարտի միջոցով, ապա պետք է տրամադրեք ձեր բանկի քարտի տվյալները: Տվյալները լրացվում են&nbsp;</span><span
        >հավելվածից</span><span
        >&nbsp;</span><span >բացվող</span><span
        >&nbsp;</span><span >ArCa</span><span
        >&nbsp;</span><span >կայքում</span><span
        >:&nbsp;</span><span
        >Կայքը</span><span >&nbsp;</span><span
        >գտնվում</span><span >&nbsp;</span><span
        >է</span><span >&nbsp;</span><span
        >Հավելվածից</span><span
        >&nbsp;</span><span >դուրս</span><span
        >&nbsp;</span><span >և</span><span
        >&nbsp;</span><span >մենք</span><span
        >&nbsp;</span><span
        >հնարավորություն</span><span
        >&nbsp;</span><span >չունենք</span><span
        >&nbsp;</span><span >մո</span><span
        >ւ</span><span >տ</span><span
        >ք&nbsp;</span><span
        >գործելու</span><span
        >&nbsp;</span><span >կայքում</span><span
        >&nbsp;</span><span >լրացված</span><span
        >&nbsp;</span><span
        >տվյալներ</span><span
        >:&nbsp;</span><span
        >Տվյալները</span><span
        >&nbsp;</span><span
        >կուղարկվեն</span><span
        >&nbsp;</span><span >ArCa</span><span
        >&nbsp;</span><span >API</span><span
        >.&nbsp;</span><span
        >Այնուհետև</span><span
        >&nbsp;</span><span >ArCa</span><span
        >-</span><span >ն</span><span
        >&nbsp;</span><span >կստուգի</span><span
        >&nbsp;</span><span >արդյոք</span><span
        >&nbsp;</span><span >Դուք</span><span
        >&nbsp;</span><span >ունեք</span><span
        >&nbsp;</span><span
        >պահանջվող</span><span
        >&nbsp;</span><span >գումարը</span><span
        >&nbsp;</span><span >Ձեր</span><span
        >&nbsp;</span><span >քարտի</span><span
        >&nbsp;</span><span
        >հասանելի</span><span
        >&nbsp;</span><span
        >մնացորդին</span><span
        >,&nbsp;</span><span >թե</span><span
        >&nbsp;</span><span >ոչ</span><span
        >&nbsp;</span><span >և</span><span
        >&nbsp;</span><span
        >կփոխանցի</span><span
        >&nbsp;</span><span >պատվերի</span><span
        >&nbsp;</span><span >գումարը</span><span
        >&nbsp;&laquo;Ալֆա-Ֆարմ&raquo; &nbsp;&nbsp;</span><span
        >ՓԲԸ</span><span >-</span><span
        >ին</span><span >:&nbsp;</span><span
        >Ձեր</span><span >&nbsp;</span><span
        >քարտի</span><span >&nbsp;</span><span
        >տվյալները</span><span
        >&nbsp;</span><span
        >Հավելվածում</span><span
        >&nbsp;</span><span
        >գոյություն</span><span
        >&nbsp;</span><span >չեն</span><span
        >&nbsp;</span><span
        >ունենալու</span><span
        >:&nbsp;</span><span >Եթե</span><span
        >&nbsp;</span><span >Դուք</span><span
        >&nbsp;</span><span >չեք</span><span
        >&nbsp;</span><span
        >ցանկանում</span><span
        >&nbsp;</span><span
        >տրամադրել</span><span
        >&nbsp;</span><span >Ձեր</span><span
        >&nbsp;</span><span
        >բանկային</span><span
        >&nbsp;</span><span >քարտի</span><span
        >&nbsp;</span><span
        >տվյալները</span><span
        >&nbsp;</span><span >Դուք</span><span
        >&nbsp;</span><span >կարող</span><span
        >&nbsp;</span><span >եք</span><span
        >&nbsp;</span><span >ընտրել</span><span
        >&nbsp;</span><span >վճարման</span><span
        >&nbsp;</span><span >այլ</span><span
        >&nbsp;</span><span
        >տարբերակներ</span><span >:</span>
    </li>
    <li ><strong><span >Hostgator</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >Hosting</span></strong><strong><span
        >&nbsp;</span></strong><strong><span
        >Services</span></strong><span >-Մենք կիրառում ենք&nbsp;</span><span
        >Hostgator</span><span
        >&nbsp;</span><span >Hosting</span><span
        >&nbsp;ծառայությունները, որպեսզի պահպանենք մեր օգտատերերի տվյալները: Դուք կարող եք գտնել ծառայությունների գաղտնության քաղաքականությունը&nbsp;</span><span
        >Hostgator</span><span
        >&nbsp;</span><span >Privacy</span><span
        >&nbsp;</span><span >Policy</span><span
        >-</span><span >ում</span><span
        >:&nbsp;</span><span >Եթե</span><span
        >&nbsp;</span><span >Դուք</span><span
        >&nbsp;</span><span
        >համաձայն</span><span
        >&nbsp;</span><span >չեք</span><span
        >&nbsp;</span><span
        >քաղաքականության</span><span
        >&nbsp;</span><span >հետ</span><span
        >,&nbsp;</span><span >ապա</span><span
        >&nbsp;</span><span
        >խորհուրդ</span><span
        >&nbsp;</span><span >չենք</span><span
        >&nbsp;</span><span >տալիս</span><span
        >&nbsp;</span><span >կիրառել</span><span
        >&nbsp;</span><span
        >Հավելվածը</span><span >:</span>
    </li>
  </ul>
  <br/>
  <p ><strong><span
      style={{color:"#70AD47"}}>Cookies /</span><span style={{color:"#70AD47"}}>Ք</span></strong><strong><span style={{color:"#70AD47"}}>ուքիսը</span></strong><strong><span
      style={{color:"#70AD47"}}>/</span></strong><span
      >&nbsp;</span><span >ֆայլեր</span><span
      >&nbsp;</span><span >են</span><span
      >&nbsp;</span><span >քիչ</span><span
      >&nbsp;</span><span
      >քանակությամբ</span><span
      >&nbsp;</span><span
      >տվյալներով</span><span
      >,&nbsp;</span><span >որոնք</span><span
      >&nbsp;</span><span >կիրառվում</span><span
      >&nbsp;</span><span >են</span><span
      >&nbsp;</span><span >որպես</span><span
      >&nbsp;</span><span >անանուն</span><span
      >&nbsp;</span><span >եզակի</span><span
      >&nbsp;</span><span
      >նույնացուցիչներ</span><span
      >:&nbsp;</span><span >Նրանք</span><span
      >&nbsp;</span><span >կարող</span><span
      >&nbsp;</span><span >են</span><span
      >&nbsp;</span><span >ուղարկվել</span><span
      >&nbsp;</span><span >Ձեր</span><span
      >&nbsp;</span><span
      >սարքավորմանը</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span
      >պահպանվում</span><span
      >&nbsp;</span><span >են</span><span
      >&nbsp;</span><span >Ձեր</span><span
      >&nbsp;</span><span
      >սարքավորման</span><span
      >&nbsp;</span><span >ներքին</span><span
      >&nbsp;</span><span
      >հիշողության</span><span
      >&nbsp;</span><span >մեջ</span><span
      >:&nbsp;</span></p>
  <p ><span >Մենք</span><span
      >&nbsp;</span><span >քուքիս</span><span
      >&nbsp;</span><span >չենք</span><span
      >&nbsp;</span><span >կիրառում</span><span
      >:&nbsp;</span><span
      >Այնուամենայնիվ</span><span >,</span><span
      >&nbsp;</span><span >երրորդ</span><span
      >&nbsp;</span><span >անձանց</span><span
      >&nbsp;</span><span >կողմից</span><span
      >&nbsp;</span><span
      >իրականացվող</span><span
      >&nbsp;</span><span
      >ծառայությունները</span><span
      >&nbsp;</span><span >կարող</span><span
      >&nbsp;</span><span >են</span><span
      >&nbsp;</span><span >կիրառել</span><span
      >&nbsp;</span><span >քուքի</span><span
      >&nbsp;</span><span >ֆայլերը</span><span
      >`&nbsp;</span><span
      >տեղեկատվություն</span><span
      >&nbsp;</span><span
      >հավաքագրելու</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span
      >ծառայությունները</span><span
      >&nbsp;</span><span
      >բարելավելու</span><span
      >&nbsp;</span><span >համար</span><span
      >:&nbsp;</span><span >Երրորդ</span><span
      >&nbsp;</span><span >անձանց</span><span
      >&nbsp;</span><span >կողմից</span><span
      >&nbsp;</span><span
      >իրականացվող</span><span
      >&nbsp;</span><span
      >ծառայությունների</span><span
      >&nbsp;</span><span >կողմից</span><span
      >&nbsp;</span><span >քուքի</span><span
      >&nbsp;</span><span >ֆայլերի</span><span
      >&nbsp;</span><span >կիրառման</span><span
      >&nbsp;</span><span >մասին</span><span
      >&nbsp;</span><span >իմանալու</span><span
      >&nbsp;</span><span >համար</span><span
      >&nbsp;</span><span >մուտք</span><span
      >&nbsp;</span><span >գործեք</span><span
      >&nbsp;</span><span >երրորդ</span><span
      >&nbsp;</span><span >անձանց</span><span
      >&nbsp;</span><span >կողմից</span><span
      >&nbsp;</span><span
      >իրականացվող</span><span
      >&nbsp;</span><span
      >ծառայությունների</span><span
      >&nbsp;</span><span
      >գաղտնիության</span><span
      >&nbsp;</span><span
      >քաղաքականություն</span><span >:</span>
  </p>
  <p ><strong><span >Անվտանգություն</span></strong><span
      >`&nbsp;</span><span >Մենք</span><span
      >&nbsp;</span><span >գնահատում</span><span
      >&nbsp;</span><span >ենք</span><span
      >,&nbsp;</span><span >որ</span><span
      >&nbsp;&nbsp;</span><span >վստահում</span><span
      >&nbsp;</span><span >եք</span><span
      >&nbsp;</span><span >ձեր</span><span
      >&nbsp;</span><span >անձնական</span><span
      >&nbsp;</span><span
      >տեղեկատվությունը</span><span
      >&nbsp;</span><span >մեզ</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span >երրորդ</span><span
      >&nbsp;</span><span >անձանց</span><span
      >&nbsp;</span><span >կողմից</span><span
      >&nbsp;</span><span
      >իրականացվող</span><span
      >&nbsp;</span><span
      >ծառայություններն</span><span
      >&nbsp;</span><span
      >ապահովողներին</span><span >,&nbsp;</span><span
      >դրա</span><span >&nbsp;</span><span
      >համար</span><span >&nbsp;</span><span
      >մենք</span><span >&nbsp;</span><span
      >ձգտում</span><span >&nbsp;</span><span
      >ենք</span><span >&nbsp;</span><span
      >կիրառել</span><span >&nbsp;</span><span
      >կոմերցիոն</span><span >&nbsp;</span><span
      >տեսանկյունից</span><span
      >&nbsp;</span><span >ընդունելի</span><span
      >&nbsp;</span><span >պաշտպանիչ</span><span
      >&nbsp;</span><span >միջոցներ</span><span
      >: &nbsp;</span><span >Բայց</span><span
      >&nbsp;</span><span >հիշեք</span><span
      >,&nbsp;</span><span >խնդրում</span><span
      >&nbsp;</span><span >եմ</span><span
      >,&nbsp;</span><span >որ</span><span
      >&nbsp;</span><span >Համացանցի</span><span
      >&nbsp;</span><span >միջոցով</span><span
      >&nbsp;</span><span
      >իրականացվող</span><span
      >&nbsp;</span><span >փոխանցման</span><span
      >&nbsp;</span><span >ոչ</span><span
      >&nbsp;</span><span >մի</span><span
      >&nbsp;</span><span >մեթոդ</span><span
      >&nbsp;</span><span >կամ</span><span
      >&nbsp;</span><span
      >էլեկտրոնային</span><span
      >&nbsp;</span><span >պահեստ</span><span
      >&nbsp;</span><span >հարյուր</span><span
      >&nbsp;</span><span >տոկոսով</span><span
      >&nbsp;</span><span >ապահով</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span >վստահելի</span><span
      >&nbsp;</span><span >չի</span><span
      >&nbsp;</span><span >կարող</span><span
      >&nbsp;</span><span >լինել</span><span
      >,&nbsp;</span><span >և</span><span
      >&nbsp;</span><span >մենք</span><span
      >&nbsp;</span><span >չենք</span><span
      >&nbsp;</span><span >կարող</span><span
      >&nbsp;</span><span
      >երաշխավորել</span><span
      >&nbsp;</span><span >դրա</span><span
      >&nbsp;</span><span >բացարձակ</span><span
      >&nbsp;</span><span
      >անվտանգությունը</span><span
      >:</span>
  </p>
  <br/>
  <br/>
  <p><strong><span >&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>Կապը</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>այլ</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>կայքերի</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>և</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>հավելվածների</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>հետ</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span></strong>
  </p>
  <p><span >Սույն</span><span
      >&nbsp;</span><span >հավելվածի</span><span
      >&nbsp;</span><span >միջոցով</span><span
      >&nbsp;</span><span >կարող</span><span
      >&nbsp;</span><span >եք</span><span
      >&nbsp;</span><span >կապ</span><span
      >&nbsp;</span><span >հաստատել</span><span
      >&nbsp;</span><span >այլ</span><span
      >&nbsp;</span><span >կայքերի</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span
      >հավելվածների</span><span
      >&nbsp;</span><span >հետ</span><span
      >:&nbsp;</span><span >Եթե</span><span
      >&nbsp;</span><span >Դուք</span><span
      >&nbsp;</span><span >քլիք</span><span
      >&nbsp;</span><span >անեք</span><span
      >&nbsp;</span><span >այդ</span><span
      >&nbsp;</span><span >կապի</span><span
      >&nbsp;</span><span >վրա</span><span
      >,&nbsp;</span><span
      >կուղղորդվեք</span><span
      >&nbsp;</span><span >դեպի</span><span
      >&nbsp;</span><span >այդ</span><span
      >&nbsp;</span><span >կայք</span><span
      >&nbsp;</span><span >կամ</span><span
      >&nbsp;</span><span >հավելված</span><span
      >:&nbsp;</span><span
      >Տեղեկացնում</span><span
      >&nbsp;</span><span >ենք</span><span
      >,&nbsp;</span><span >որ</span><span
      >&nbsp;</span><span >այդ</span><span
      >&nbsp;</span><span >արտաքին</span><span
      >&nbsp;</span><span >կայքերն</span><span
      >&nbsp;</span><span >ու</span><span
      >&nbsp;</span><span
      >հավելվածները</span><span
      >&nbsp;</span><span >մեր</span><span
      >&nbsp;</span><span >կողմից</span><span
      >&nbsp;</span><span >չեն</span><span
      >&nbsp;</span><span
      >կառավարվում</span><span
      >:&nbsp;</span><span >Մենք</span><span
      >&nbsp;</span><span >չեն</span><span
      >&nbsp;</span><span
      >կառավարում</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span
      >պատասխանատվություն</span><span
      >&nbsp;</span><span >չենք</span><span
      >&nbsp;</span><span >կրում</span><span
      >&nbsp;</span><span >երրորդ</span><span
      >&nbsp;</span><span >անձանց</span><span
      >&nbsp;</span><span >կայքերի</span><span
      >,&nbsp;</span><span
      >հավելվածների</span><span
      >&nbsp;</span><span >կամ</span><span
      >&nbsp;</span><span
      >ծառայությունների</span><span
      >&nbsp;</span><span >կիրառման</span><span
      >&nbsp;</span><span >բովանդակության</span><span
      >,&nbsp;</span><span >կիրառման</span><span
      >&nbsp;</span><span
      >ժամկետների</span><span
      >,&nbsp;</span><span
      >գաղտնիության</span><span
      >&nbsp;</span><span
      >քաղաքականությունների</span><span
      >&nbsp;</span><span >համար</span><span
      >:</span></p>
  <p><strong><span style={{color:"#70AD47"}}>Սույն</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>Գաղտնիության</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>քաղաքականության</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>ընդունումը</span></strong></p>
  <p><span >Հավելվածի</span><span >&nbsp;</span><span
      >Ձեր</span><span >&nbsp;</span><span
      >շարունակական</span><span
      >&nbsp;</span><span >կիրառումը</span><span
      >&nbsp;</span><span >կհամարվի</span><span
      >&nbsp;&nbsp;</span><span
      >որպես</span><span >&nbsp;</span><span
      >Գաղտնիության</span><span
      >&nbsp;</span><span
      >քաղաքականության</span><span
      >&nbsp;</span><span >ընդունում</span><span
      >,&nbsp;</span><span >սույն</span><span
      >&nbsp;</span><span
      >քաղաքականության</span><span
      >&nbsp;</span><span
      >վերաբերյալ</span><span
      >&nbsp;</span><span >տեղեկատվության</span><span
      >&nbsp;</span><span
      >հավաքագրում</span><span
      >&nbsp;</span><span >և</span><span
      >&nbsp;</span><span >կիրառում</span><span
      >:</span></p>
  <p ><strong><span >&nbsp;</span></strong></p>
  <p ><strong><span style={{color:"#70AD47"}}>Փոփոխություններ սույն Գաղտնիության Քաղաքականության վերաբերյալ</span></strong>
  </p>
  <p ><span >Մենք կարող ենք վերանայել մեր Գաղտնիության&nbsp;</span><span  >Քաղաքականությունը ժամանակ առ ժամանակ: Այսպիսով`խորհուրդ ենք տալիս աչքի անցկացնել այս էջը պարբերաբար` փոփոխությունների ծանոթանալու համար: Մենք &nbsp;ձեզ կտեղեկացնենք ցանկացած փոփոխության մասին` տեղադրելով &nbsp;նոր Գաղտնիության Քաղաքականությունը այս էջում: Սույն փոփոխությունները գործում են անմիջապես սույն էջում դրանք տեղադրելուց հետո:</span>
  </p>
  <p ><strong><span >&nbsp;</span></strong></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Կապը մեր հետ`</span></strong></p>
  <p ><span >Եթե ունեք հարցեր կամ առաջարկություններ սույն Գաղտնիության Քաղաքականության մասին, կապվեք մեր հետ</span>
  </p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Քաղաքականության</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>գործող</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>ամսաթիվը</span></strong><strong><span
      style={{color:"#70AD47"}}>`</span></strong><strong><span
      >&nbsp;</span></strong></p>
  <p ><span >Սույն</span><span
      >&nbsp;</span><span
      >քաղաքականությունը</span><span
      >&nbsp;</span><span >գործում</span><span
      >&nbsp;</span><span >է</span><span
      >&nbsp;</span><span >առ</span><span
      >&nbsp; &nbsp;2018 &nbsp;թվականի հոկտեմբերի 17</span></p>
  <p ><span >&nbsp;</span></p>
  <p ><span >&nbsp;</span></p>
  <p ><span >&nbsp;</span></p>
  <p ><strong><span
      style={{fontSize:"21px",color:"#70AD47"}}>Alfa</span></strong><strong><span
      style={{fontSize:"21px",color:"#70AD47"}}>-</span></strong><strong><span
      style={{fontSize:"21px",color:"#70AD47"}}>Pharm հավելվածի օգտագործման պայմանները</span></strong>
  </p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Ներածություն</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong></p>
  <p ><span
      >Շնորհակալություն</span><span
      >&nbsp;AlfaPharm հավելվածն (application) (այսուհետ նաև՝ Հավելված) &nbsp;</span><span
      >օգտագործելու</span><span
      >&nbsp;</span><span
      >համար</span><span
      >: Հավելված</span><span
      >ը</span><span
      >&nbsp;&laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերության`&nbsp;</span><span
      >գտնվող</span><span
      >&nbsp;ՀՀ, ք. Երևան, Շիրակի 1/68&nbsp;</span><span
      >կողմից</span><span
      >&nbsp;</span><span
      >տրամադրվող</span><span
      >&nbsp;անհատույց&nbsp;</span><span
      >ծառայություն</span><span
      >&nbsp;</span><span
      >է</span><span
      >: Հավելված</span><span
      >ի</span><span
      >&nbsp;</span><span
      >օգտագործումը</span><span
      >&nbsp;</span><span
      >պետք</span><span
      >&nbsp;</span><span
      >է</span><span
      >&nbsp;</span><span
      >համապատասխանի</span><span
      >&nbsp;Հավելված</span><span
      >ի</span><span
      >&nbsp;</span><span
      >օգտագործման</span><span
      >&nbsp;</span><span
      >պայմաններին</span><span
      >&nbsp;(</span><span
      >այսուհետ՝</span><span
      >&nbsp;
    <strong>&laquo;</strong></span><strong><span
      >Պայմաններ</span></strong><strong><span
      >&raquo;</span></strong><span
      >):&nbsp;</span></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong>
  </p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Տեղեկատվության</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>հասանելիություն</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>և</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>օգտագործում</span></strong>
  </p>
  <p ><span
      >Դուք</span><span
      >&nbsp;</span><span
      >կարող</span><span
      >&nbsp;</span><span
      >եք</span><span
      >&nbsp;</span><span
      >օգտագործել</span><span
      >&nbsp;Հավելված</span><span
      >ը</span><span
      >&nbsp;</span><span
      >Ձեր</span><span
      >&nbsp;</span><span
      >հեռախոսում</span><span
      >&nbsp;(</span><span
      >այսուհետ՝</span><span
      >&nbsp;
    <strong>&laquo;</strong></span><strong><span
      >Սարք</span></strong><strong><span
      >&raquo;</span></strong><span
      >) &laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերության դեղատնային ցանցի կողմից մատուցվող ծառայությունների վերաբերյալ&nbsp;</span><span
      >տեղեկատվություն</span><span
      >&nbsp;</span><span
      >դիտարկելու</span><span
      >,&nbsp;</span><span
      >գտնելու</span><span
      >, ինչպես նաև առցանց պատվերներ իրականացնելու&nbsp;</span><span
      >համար</span><span
      >: &laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերությունը&nbsp;</span><span
      >պատասխանատվություն</span><span
      >&nbsp;</span><span
      >չի</span><span
      >&nbsp;</span><span
      >կրում</span><span
      >&nbsp;Հավելված</span><span
      >ից բացի</span><span
      >&nbsp;</span><span
      >այլ</span><span
      >&nbsp;</span><span
      >հավելվածի</span><span
      >&nbsp;</span><span
      >միջոցով</span><span
      >&nbsp;&laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերության դեղատնային ցանցի վերաբերյալ&nbsp;</span><span
      >հասանելի</span><span
      >&nbsp;</span><span
      >դարձած</span><span
      >&nbsp;</span><span
      >որևէ</span><span
      >&nbsp;</span><span
      >Տեղեկատվության</span><span
      >&nbsp;</span><span
      >համար</span><span
      >։</span></p>
  <p ><span
      >&nbsp;</span></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Թարմացումներ</span></strong>
  </p>
  <p ><span
      >Հավելված</span><span
      >ի</span><span
      >&nbsp;</span><span
      >կառուցվածքը</span><span
      >&nbsp;</span><span
      >և</span><span
      >&nbsp;</span><span
      >Տեղեկատվությունը</span><span
      >&nbsp;</span><span
      >հնարավոր</span><span
      >&nbsp;</span><span
      >է</span><span
      >&nbsp;</span><span
      >թարմացման</span><span
      >&nbsp;</span><span
      >կարիք</span><span
      >&nbsp;</span><span
      >ունենան</span><span
      >,&nbsp;</span><span
      >օրինակ՝</span><span
      >&nbsp;</span><span
      >վրիպակների</span><span
      >&nbsp;</span><span
      >շտկման</span><span
      >,&nbsp;</span><span
      >գործառույթների</span><span
      >&nbsp;</span><span
      >ընդլայնման</span><span
      >,&nbsp;</span><span
      >փլագինների</span><span
      >&nbsp;</span><span
      >ավելացման</span><span
      >&nbsp;</span><span
      >կամ</span><span
      >&nbsp;</span><span
      >նոր</span><span
      >&nbsp;</span><span
      >տարբերակների</span><span
      >&nbsp;</span><span
      >համար</span><span
      >&nbsp;(</span><span
      >հավաքական՝</span><span
      >&nbsp;
    <strong>&laquo;</strong></span><strong><span
      >Թարմացումներ</span></strong><strong><span
      >&raquo;</span></strong><span
      >):&nbsp;</span><span
      >Նման</span><span
      >&nbsp;</span><span
      >թարմացումները</span><span
      >&nbsp;</span><span
      >կարող</span><span
      >&nbsp;</span><span
      >են</span><span
      >&nbsp;</span><span
      >պահանջվել</span><span
      >,&nbsp;</span><span
      >որպեսզի</span><span
      >&nbsp;</span><span
      >Դուք</span><span
      >&nbsp;</span><span
      >կարողանաք</span><span
      >&nbsp;</span><span
      >օգտագործել</span><span
      >&nbsp;Հավելված</span><span
      >ը: Ընդունելով</span><span
      >&nbsp;</span><span
      >այս</span><span
      >&nbsp;</span><span
      >պայմաններն</span><span
      >&nbsp;</span><span
      >ու</span><span
      >&nbsp;</span><span
      >օգտագործելով</span><span
      >&nbsp;Հավելված</span><span
      >ը՝</span><span
      >&nbsp;</span><span
      >Դուք</span><span
      >&nbsp;</span><span
      >համաձայնում</span><span
      >&nbsp;</span><span
      >եք</span><span
      >&nbsp;</span><span
      >ավտոմատ</span><span
      >&nbsp;</span><span
      >ստանալ</span><span
      >&nbsp;</span><span
      >նշված</span><span
      >&nbsp;</span><span
      >Թարմացումները</span><span
      >:</span></p>
  <p ><strong><span
      >&nbsp;</span></strong></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Գնումներ և Վճարումներ:&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>Ապրանքի (Դեղեր, բուժ. պարագաներ և ոչ պարենային ապրանքներ, մանկական սնունդ)</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>գնում</span></strong></p>
  <p ><span
      >Երբ</span><span
      >&nbsp;</span><span
      >Դուք</span><span
      >&nbsp;հավելվածի միջոցով&nbsp;</span><span
      >գնում</span><span
      >&nbsp;</span><span
      >եք</span><span
      >&nbsp;</span><span
      >Ապրանք</span><span
      >,&nbsp;</span><span
      >Դուք</span><span
      >&nbsp;</span><span
      >ըստ</span><span
      >&nbsp;</span><span
      >այս</span><span
      >&nbsp;</span><span
      >Պայմանների</span><span
      >&nbsp;</span><span
      >առանձին</span><span
      >&nbsp;</span><span
      >գործարք</span><span
      >&nbsp;</span><span
      >եք</span><span
      >&nbsp;</span><span
      >կնքում</span><span
      >&nbsp;(</span><span
      >կիրառելիության</span><span
      >&nbsp;</span><span
      >դեպքում</span><span
      >)&nbsp;</span><span
      >վաճառողի</span><span
      >&nbsp;</span><span
      >հետ</span><span
      >,&nbsp;</span><span
      >որը</span><span
      >&nbsp;</span><span
      >հանդիսանում է&nbsp;</span><span
      >&nbsp;&laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերությունը:</span>
  </p>
  <p ><span
      >Գնման</span><span
      >&nbsp;</span><span
      >առանձին</span><span
      >&nbsp;</span><span
      >գործարքը</span><span
      >&nbsp;</span><span
      >հանդիսանում</span><span
      >&nbsp;</span><span
      >է</span><span
      >&nbsp;</span><span
      >այս</span><span
      >&nbsp;</span><span
      >Պայմանների</span><span
      >&nbsp;</span><span
      >լրացում</span><span
      >։</span></p>
  <p ><span
      >Ապրանքի</span><span
      >&nbsp;</span><span
      >գնման</span><span
      >&nbsp;</span><span
      >գործարքը</span><span
      >&nbsp;</span><span
      >համարվում</span><span
      >&nbsp;</span><span
      >է</span><span
      >&nbsp;</span><span
      >կնքված</span><span
      >&nbsp;</span><span
      >այն</span><span
      >&nbsp;</span><span
      >պահին</span><span
      >,&nbsp;</span><span
      >երբ</span><span
      >&nbsp;</span><span
      >ստանում</span><span
      >&nbsp;</span><span
      >եք</span><span
      >&nbsp;</span><span
      >հաղորդագրություն</span><span
      >,&nbsp;</span><span
      >որով</span><span
      >&nbsp;</span><span
      >հաստատվում</span><span
      >&nbsp;</span><span
      >է</span><span
      >&nbsp;</span><span
      >ապրանքի</span><span
      >&nbsp;</span><span
      >գնումը</span><span
      >,&nbsp;</span><span
      >և</span><span
      >&nbsp;</span><span
      >այս</span><span
      >&nbsp;</span><span
      >գործարքն</span><span
      >&nbsp;</span><span
      >ուժի</span><span
      >&nbsp;</span><span
      >մեջ</span><span
      >&nbsp;</span><span
      >է</span><span
      >&nbsp;</span><span
      >մտնում</span><span
      >&nbsp;</span><span
      >անմիջապես</span><span
      >,&nbsp;</span><span
      >երբ</span><span
      >&nbsp;</span><span
      >գնումն</span><span
      >&nbsp;</span><span
      >ավարտվում</span><span
      >&nbsp;</span><span
      >է</span><span
      >։</span></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Նախնական</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>պատվերներ</span></strong></p>
  <p ><span
      >Երբ</span><span
      >&nbsp;</span><span
      >Դուք</span><span
      >&nbsp;</span><span
      >տեղադրում</span><span
      >&nbsp;</span><span
      >եք</span><span
      >&nbsp;</span><span
      >ապրանքի</span><span
      >&nbsp;</span><span
      >համար</span><span
      >&nbsp;</span><span
      >նախնական</span><span
      >&nbsp;</span><span
      >պատվեր</span><span
      >,&nbsp;</span><span
      >այդ</span><span
      >&nbsp;</span><span
      >ապրանքի</span><span
      >&nbsp;</span><span
      >գնման</span><span
      >&nbsp;</span><span
      >գործարքը</span><span
      >&nbsp;</span><span
      >կնքվում</span><span
      >&nbsp;</span><span
      >է</span><span
      >,&nbsp;</span><span
      >երբ</span><span
      >&nbsp; Ձեզ ուղարկվում &nbsp;է հաղորդագրություն պատվերը &nbsp;ընկերության կողմից հաստատելու մասին:&nbsp;</span>
  </p>
  <p ><strong><span>&nbsp;</span></strong></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Վճարումների</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>կատարման</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>եղանակներ</span></strong></p>
  <p ><span
      >Հավելված</span><span
      >ի</span><span
      >&nbsp;</span><span
      >միջոցով</span><span
      >&nbsp;</span><span
      >ապրանք գնելիս Դուք</span><span
      >&nbsp;կարող եք ընտրել վճարման եղանակներից մեկը՝&nbsp;</span>
  </p>
  <ul style={{listStyleType:" undefined"}}>
    <li><span>Կանխիկ</span><span
       >` առաքման պահին</span></li>
    <li><span>Բանկային տերմինալի միջոցով` առաքման պահին</span>
    </li>
    <li><span>Առցանց՝ հավելվածի օգնությամբ</span>
    </li>
  </ul>
  <p ><span
      >Բանկային քարտով վճարում կատարելիս Դուք</span><span
      >&nbsp;</span><span
      >պետք</span><span
      >&nbsp;</span><span
      >է</span><span
      >&nbsp;</span><span
      >ենթարկվեք</span><span
      >&nbsp;</span><span
      >երրորդ</span><span
      >&nbsp;</span><span
      >անձի</span><span
      >&nbsp;</span><span
      >հետ</span><span
      >&nbsp;</span><span
      >կնքված</span><span
      >&nbsp;</span><span
      >վերաբերելի</span><span
      >&nbsp;</span><span
      >պայմաններին</span><span
      >&nbsp;</span><span
      >կամ</span><span
      >&nbsp;</span><span
      >այլ</span><span
      >&nbsp;</span><span
      >իրավական</span><span
      >&nbsp;</span><span
      >համաձայնագրին</span><span
      >,&nbsp;</span><span
      >որը</span><span
      >&nbsp;</span><span
      >կարգավորում</span><span
      >&nbsp;</span><span
      >է</span><span
      >&nbsp;</span><span
      >վճարման</span><span
      >&nbsp;</span><span
      >կատարման</span><span
      >&nbsp;</span><span
      >տվյալ</span><span
      >&nbsp;</span><span
      >եղանակի</span><span
      >&nbsp;</span><span
      >օգտագործումը</span><span
      >:&nbsp;</span><span
      >Դուք</span><span
      >&nbsp;</span><span
      >ինքնուրույն</span><span
      >&nbsp;</span><span
      >պատասխանատվություն</span><span
      >&nbsp;</span><span
      >եք</span><span
      >&nbsp;</span><span
      >կրում</span><span
      >&nbsp;<span
      >Հավելված</span></span><span
      >ում</span><span
      >&nbsp;</span><span
      >Ձեր</span><span
      >&nbsp;</span><span
      >կողմից</span><span
      >&nbsp;</span><span
      >կատարվող</span><span
      >&nbsp;</span><span
      >բոլոր</span><span
      >&nbsp;</span><span
      >վճարումների</span><span
      >&nbsp;</span><span
      >հետ</span><span
      >&nbsp;</span><span
      >կապված</span><span
      >&nbsp;</span><span
      >վճարման</span><span
      >&nbsp;</span><span
      >ենթակա</span><span
      >&nbsp;</span><span
      >բոլոր</span><span
      >&nbsp;</span><span
      >գումարների</span><span
      >&nbsp;</span><span
      >համար</span><span
      >:</span></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Գներ</span></strong></p>
  <p ><span
      >Հավելված</span><span
      >ում</span><span
      >&nbsp;</span><span
      >ներկայացված</span><span
      >&nbsp;</span><span
      >ապրանքի</span><span
      >&nbsp;</span><span
      >գներն</span><span
      >&nbsp;</span><span
      >ու</span><span
      >&nbsp;</span><span
      >հասանելիությունը</span><span
      >&nbsp;</span><span
      >մինչև</span><span
      >&nbsp;</span><span
      >գնումը</span><span
      >&nbsp;</span><span
      >ցանկացած</span><span
      >&nbsp;</span><span
      >պահի</span><span
      >&nbsp;</span><span
      >կարող</span><span
      >&nbsp;</span><span
      >են</span><span
      >&nbsp;</span><span
      >փոփոխվել</span><span
      >:</span></p>
  <p ><span
      >Տեխնիկական պատճառներով հնարավոր են ապրանքների գների և ապրանքների նկարների ոչ զգալի անհամապատասխանություններ:&nbsp;</span>
  </p>
  <p ><span
      >Գնային տարբերության և/կամ նկարների անհամապատասխանության դեպքում կարող եք զանգահարել +374 60&nbsp;700&nbsp;500 ներք. 1 հեռախոսահամարին կամ խնդրի մասին գրավոր ներկայացնել &laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերության պաշտոնական էլ</span><span
      >եկտրոնային&nbsp;</span><span
      >հասցեին`<u>online@alfapharm.am</u>։&nbsp;</span>
  </p>
  <p ><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Բոլոր</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>վաճառքները</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>հանդիսանում</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>են</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>վերջնական</span></strong></p>
  <p ><span
      >Բոլոր</span><span
      >&nbsp;</span><span
      >վաճառքները</span><span
      >&nbsp;</span><span
      >հանդիսանում</span><span
      >&nbsp;</span><span
      >են</span><span
      >&nbsp;</span><span
      >վերջնական</span><span
      >&nbsp;</span><span
      >և</span><span
      >&nbsp;</span><span
      >վերադարձ</span><span
      >,&nbsp;</span><span
      >փոխանակում</span><span
      >&nbsp;</span><span
      >ու</span><span
      >&nbsp;</span><span
      >հետվճարում</span><span
      >&nbsp;</span><span
      >չի</span><span
      >&nbsp;</span><span
      >կատարվում, բացառությամբ</span><span
      >&nbsp;հավելվածում գնման պահին առկա տեխնիկական սխալների հետևանքով առկա սխալմունքների պատճառող ապրանքների վերաբեյալ ոչ ճշգրիտ տեղեկատվության դեպքերի, ինչպես նաև ՀՀ օրենսդրությամբ սահմանված ժամկետում և ապրանքների&nbsp;</span><span
      >&nbsp;վերադարձման դեպքերի։</span><span
      >&nbsp;</span><span
      >Եթե</span><span
      >&nbsp;</span><span
      >գործարքի</span><span
      >&nbsp;</span><span
      >համար</span><span
      >&nbsp;</span><span
      >նախատեսված</span><span
      >&nbsp;</span><span
      >է</span><span
      >&nbsp;</span><span
      >փոխարինում</span><span
      >,&nbsp;</span><span
      >վերադարձ</span><span
      >&nbsp;</span><span
      >կամ</span><span
      >&nbsp;</span><span
      >հետվճարում</span><span
      >,&nbsp;</span><span
      >ապա</span><span
      >&nbsp;</span><span
      >այն</span><span
      >&nbsp;</span><span
      >կարող</span><span
      >&nbsp;</span><span
      >է</span><span
      >&nbsp;</span><span
      >չեղարկվել</span><span
      >:&nbsp;</span></p>
  <p ><span
      >&nbsp;</span></p>
  <p ><strong><span
      style={{fontSize:"21px",color:"ED7D31"}}>Իրավունքներ և պարտականություններ</span></strong>
  </p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Հավելված</span></strong><strong><span
      style={{color:"#70AD47"}}>ի&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>օգտատերն իրավունք ունի ՝</span></strong>
  </p>
  <ul style={{listStyleType:" undefined"}}>
    <li><span>Անվճար հիմունքներով օգտագործել հավելվածը,&nbsp;</span>
    </li>
    <li><span>Դիտարկել</span><span
       >,&nbsp;</span><span
       >գտնել</span><span
       >&nbsp;</span><span
       >տեղեկատվություն</span><span
        >&nbsp;</span><span
        >հավելվածում,</span><span
        >&nbsp;</span></li>
    <li><span>Հավելված</span><span
       >ի միջոցով &laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերությունից գնել հավելվածում ցուցադրված ապրանքները,</span>
    </li>
    <li><span>Ապրանքի գնման պատվերը չեղարկել մինչև պատվերը հաստատող հաղորդագրությունը ստանալը,&nbsp;</span>
    </li>
    <li><span
       >&laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերության դեղատնային ցանցի վերաբերյալ ստանալ ճշգրիտ տեղեկատվություն,</span>
    </li>
    <li><span>Առկայության դեպքում կուտակային քարտի վերաբերյալ ստանալ տեղեկատվություն,</span>
    </li>
    <li><span>Առկայության դեպքում կուտակային քարտի տվյալներն օգտագործել &laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերության դեղատնային ցանցում միավորներ կուտակելու համար,&nbsp;</span>
    </li>
    <li><span
       >Առկայության դեպքում &laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերության դեղատնային ցանցում գնումներ կատարելիս օգտագործել կուտակային քարտում առկա միավորները:</span>
    </li>
  </ul>
  <p ><strong><span
      >&nbsp;</span></strong></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Հավելված</span></strong><strong><span
      style={{color:"#70AD47"}}>ի&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>օգտատերը պարտավոր է՝</span></strong>
  </p>
  <p ><span
      >Հավելվածում գրանցվելիս և &nbsp;ապրանքի գնման պատվեր կատարելիս տրամադրել ճշգրիտ տեղեկատվություն,&nbsp;</span>
  </p>
  <p ><span
      >Ապրանքի գնման պատվերը չեղարկել մինչև պատվերը հաստատող հաղորդագրությունը ստանալը,&nbsp;</span>
  </p>
  <p ><strong><span
      >&nbsp;</span></strong></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>&laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերությունը իրավունք ունի՝&nbsp;</span></strong>
  </p>
  <p ><span
      >Հավաքագրել օգտատերի վերաբերյալ տեղեկատվություն (անուն-ազգանուն, էլեկտրոնային հասցեն, առաքման հասցեն)</span>
  </p>
  <p ><span
      >Հավաքագրված տեղեկատվությունը տրամադրել &laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերության համապատասխան ստորաբաժանումներին՝ ապրանքների առաքումը իրականացնելու համար:&nbsp;</span>
  </p>
  <p ><strong><span
      style={{color:"#70AD47"}}>&laquo;Ալֆա-Ֆարմ&raquo; ՓԲ ընկերությունը պարտավոր է՝&nbsp;</span></strong>
  </p>
  <p ><span
      >Հավելվածում տեղադրել ճշգրիտ տեղեկատվություն,&nbsp;</span>
  </p>
  <p ><span
      >Առաքել պատշաճ որակի ապրանքներ,&nbsp;</span></p>
  <p ><span
      >Առկայության դեպքում և հավելվածի օգտատերի պահանջով վերջինիս կուտակային քարտին կուտակել միավորներ,&nbsp;</span>
  </p>
  <p ><span
      >Ընդունել պատվերի չեղարկումը, եթե այն կատարվել է մինչև առաքման գործընթացը սկսելը,</span>
  </p>
  <p ><span
      >Օգտատերերի վերաբերյալ տեղեկատվությունը չտրամադրել երրորդ անձանց:&nbsp;</span>
  </p>
  <p><strong><span style={{fontSize:"16px",color:"#70AD47"}}>Պատվերի ընդունման և առաքման պայմաններ</span></strong>
  </p>
  <p style={{fontSize:"19px",color:"#ED7D31"}}><span >&nbsp;</span></p>
  <ul className="decimal_type" style={{listStyleType:" undefined"}}>
    <li><span>Առաքումն իրականացվում է Երևանի ամբողջ տարածքով</span>
    </li>
    <li><span>Պատվերները ընդունվում են և առաքվում են շաբաթվա բոլոր օրերին` օրը 24 ժամ&nbsp;</span>
    </li>
    <li><span>Պատվերի մինիմալ արժեքը պետք է կազմի 2000 ՀՀ դրամ</span>
    </li>
    <li><span>Մինչև 10000 ՀՀ դրամ արժողությամբ պատվերների առաքման ծառայության վճարը կազմում է 500 ՀՀ դրամ</span>
    </li>
    <li><span>10000 ՀՀ դրամից բարձր արժողությամբ պատվերները առաքվում են անվճար</span>
    </li>
    <li><span>Մեր դեղագետ-օպերատորները շուրջօրյա հասանելի են 060 700&nbsp;500 ներք. 1 հեռախոսահամարով</span>
    </li>
    <li><span>Պատվերը ստանալուց հետո մեր դեղագետ-օպերատորը կապ կհաստատի Ձեզ հետ պատվերի հետ կապված մանրամասները ճշտելու համար</span>
    </li>
  </ul>
  <p><span >&nbsp;</span></p>
  <p><strong><span >&nbsp;</span></strong></p>
  <p><strong><span
      style={{fontSize:"16px",color:"#70AD47"}}>Վճարման</span></strong><strong><span
      style={{fontSize:"16px",color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{fontSize:"16px",color:"#70AD47"}}>պայմաններ</span></strong></p>
  <p><span >&nbsp;</span></p>
  <p><span >Վճարումը</span><span
      >&nbsp;</span><span >կարող</span><span
      >&nbsp;</span><span >է</span><span
      >&nbsp;</span><span >կատարվել`</span></p>
  <p><span >&nbsp;</span></p>
  <ul style={{listStyleType:" undefined"}}>
    <li><span>Կանխիկ</span><span
       >` առաքման պահին</span></li>
    <li><span>Բանկային տերմինալի միջոցով` առաքման պահին</span>
    </li>
    <li><span>Առցանց՝ հավելվածի օգնությամբ</span>
    </li>
  </ul>
  <p><span >&nbsp;</span></p>
  <p><strong><span >&nbsp;</span></strong></p>
  <p><strong><span style={{fontSize:"16px",color:"#70AD47"}}>Վերադարձի պայմաններ&nbsp;</span></strong></p>
  <p><span >Առաքված</span><span>&nbsp;</span><span
      >պատվերից</span><span
      >&nbsp;</span><span
      >և</span><span
      >&nbsp;</span><span
      >նրա</span><span
      >&nbsp;</span><span
      >վճարումից</span><span
      >&nbsp;</span><span
      >հնարավոր</span><span
      >&nbsp;</span><span
      >է</span><span
      >&nbsp;</span><span
      >հրաժարվել</span><span
      >&nbsp;</span><span
      >հետևյալ</span><span
      >&nbsp;</span><span
      >դեպքերում.</span></p>
  <p><span >&nbsp;</span></p>
  <ul style={{listStyleType:" undefined"}}>
    <li><span>Առաքված ապրանքը տարբերվում է պատվիրված ապրանքից</span>
    </li>
    <li><span>Վնասված է ապրանքի փաթեթավորումը</span>
    </li>
    <li><span>Տեղափոխության ժամանակ խախտվել են ապրանքի պահպանման պայմանները</span>
    </li>
    <li><span>Ապրանքը վերադարձի ենթակա է միայն առաքման պահին</span>
    </li>
  </ul>
  <p ><span
      >&nbsp;</span></p>
  <p ><strong><span
      style={{color:"#70AD47"}}>Այս</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>Պայմանների</span></strong><strong><span
      style={{color:"#70AD47"}}>&nbsp;</span></strong><strong><span
      style={{color:"#70AD47"}}>փոփոխությունները</span></strong></p>
  <p ><span>Այս</span><span
      >&nbsp;</span><span
      >Պայմանները</span><span
      >&nbsp;</span><span
      >փոփոխվելու</span><span
      >&nbsp;</span><span
      >դեպքում</span><span
      >&nbsp;</span><span
      >Դուք</span><span
      >&nbsp;</span><span
      >կստանաք</span><span
      >&nbsp;</span><span
      >ծանուցում</span><span
      >,&nbsp;</span><span
      >և</span><span
      >&nbsp;</span><span
      >նոր</span><span
      >&nbsp;</span><span
      >Պայմաններն</span><span
      >&nbsp;</span><span
      >ուժի</span><span
      >&nbsp;</span><span
      >մեջ</span><span
      >&nbsp;</span><span
      >կմտնեն</span><span
      >&nbsp;</span><span
      >այդ</span><span
      >&nbsp;</span><span
      >ծանուցման</span><span
      >&nbsp;</span><span
      >ժամկետից</span><span
      >&nbsp;</span><span
      >հետո</span><span
      >:&nbsp;</span><span
      >Նոր</span><span
      >&nbsp;</span><span
      >Պայմանները</span><span
      >&nbsp;</span><span
      >կկիրառվեն</span><span
      >&nbsp;</span><span
      >Ձեր</span><span
      >&nbsp;</span><span
      >կողմից</span><span
      >&nbsp;</span><span
      >ամբողջ</span><span
      >&nbsp;</span><span
      >Տեղեկատվության</span><span
      >&nbsp;</span><span
      >օգտագործման</span><span
      >&nbsp;</span><span
      >և</span><span
      >&nbsp;</span><span
      >բոլոր</span><span
      >&nbsp;</span><span
      >հետագա</span><span
      >&nbsp;</span><span
      >տեղադրումների</span><span
      >&nbsp;</span><span
      >և</span><span
      >&nbsp;</span><span
      >գնումների</span><span
      >&nbsp;</span><span
      >նկատմամբ</span><span
      >:&nbsp;</span><span
      >Եթե</span><span
      >&nbsp;</span><span
      >Դուք</span><span
      >&nbsp;</span><span
      >համաձայն</span><span
      >&nbsp;</span><span
      >չեք</span><span
      >&nbsp;</span><span
      >նման</span><span
      >&nbsp;</span><span
      >փոփոխությունների</span><span
      >&nbsp;</span><span
      >հետ</span><span
      >,&nbsp;</span><span
      >Ձեզ</span><span
      >&nbsp;</span><span
      >հնարավորություն</span><span
      >&nbsp;</span><span
      >կտրվի</span><span
      >&nbsp;</span><span
      >դադարեցնել</span><span
      >&nbsp;Հավելված</span><span
      >ի</span><span
      >&nbsp;</span><span
      >Ձեր</span><span
      >&nbsp;</span><span
      >օգտագործումը</span><span
      >:&nbsp;</span></p>

</>

const faqTexts = [{
  title: "Ապրանքի ետ վերադարձ",
  description: <>
    Ետ վերադարձը կատարվում է գնման պահից 14 օրվա ընթացքում: Կարող եք կատարել ետ վերադարձ առաքված ապրանքը բերելով ineed.am-ի գրասենյակ: Անհրաժեշտ է ներկայացնել անձնագիր և վաճառքի կտրոն:
  </>,
}, {
  title: "ԳՐԱՆՑՈՒՄ",
  description: <>
    <b>Ինչպե՞ս գրանցվել</b><br />
    Գրանցվելու համար սեղմեք գրանցվել կոճակի վրա, խնդրում ենք մուտքագրել ստորեւ բերված դաշտերը եվ նորից սեղմել ներքեւի հատվածում, որի վրա գրված է գրանցվել, լրացնելուց հետո Ձեր էլ. փոստին կուղարկվի նամակ, գրանցումը ակտիվացնելու համար: Համակարգում գրանցումը Ձեզ կօգնի ունենալ անձնական էջ, որտեղ  հետագայում տեսնել Ձեր գնումների պատմությունը եւ որպես մշտական հաճախորդ ստանալ կայքում նորությունների վերաբերյալ տեղեկատվություն:<br /><br />
    <b>Կարո՞ղ եմ գրանցվել այլ համակարգերի միջոցով</b><br />
    Դուք կարող եք գրանցվել facebook, google+ սոցիալական կայքերի միջոցով:<br /><br />
    <b>Հնարավո՞ր է արդյոք կատարել գնումներ առանց գրանցվելու</b><br />
    Այո հնարավոր է, Դուք կարող եք բաց թողնել «Գրանցվել» դաշտը եվ կատարել գնումներ հյուրի կարգավիճակով, սակայն Ձեր գնումների պատմությունը չի պահպանվի համակարգում:<br /><br />
    <b>Ես մոռացել եմ իմ գրացման գաղտնաբառը</b><br />
    Սեղմեք &lt;&lt;մոռացել եք գաղտնաբառը&gt;&gt; վանդակի վրա եվ կստանաք հաղորդագրություն Ձեր էլ.հասցեին:
  </>,
}, {
  title: "ԱՊՐԱՆՔԱՏԵՍԱԿԱՆԻ",
  description: <>
    <b>Ինչպե՞ս գտնեմ ինձ անհրաժեշտ ապրանքը</b><br />
    &lt;&lt;Ի՞նչ է Ձեզ հարկավոր&gt;&gt; դաշտում լրացրեք ապրանքի անվանումը , չափման միավորը, քանակությունը: Կարող եք նաև նկարագրել ապրանքը համապատասխան բաժնում, ինչպես նաև կցել նկարներ, ֆայլեր կամ գծագրեր: Սեղմեք պատվիրել կոճակը և մենք կդիտարկենք պատվերը, այնուհետև հետադարձ կապով կուղարկենք գնային առաջարկ:<br /><br />
    <b>Ինչպե՞ս վճարել</b><br />
    Վճարել կարելի է՝<br />
    Կանխիկ՝ վճարելով անմիջապես առաքիչին,<br />
    Օնլայն՝ կայքում նշված տարբերակներից որևէ մեկով,<br />
    Փոխանցումով՝ հաշիվ-ապրանքագրի հիման վրա:<br /><br />
    <b>Կարո՞ղ եմ ստանալ հաշիվ-ապրանքագիր</b><br />
    Հաշիվ ապրանքագիր ստանալու համար անհրաժեշտ է նշել լրացումներ դաշտում կամ զանգել 011200900 հեռախոսահամարով:<br /><br />
    <b>Կարո՞ղ եմ վճարել արտասահմանից, արտասահմանյան քարտերով</b><br />
    Վճարումը հնարավոր է իրականացնել աշխարհի ցանկացած հատվածում IDRAM համակարգով, VISA, MASTER եվ ARCA (անհրաժեշտ է վիրտուալ գրանցում ունենալ) բանկային քարտերով:
  </>,
}, {
  title: "ԱՌԱՔՈՒՄ",
  description: <>
    <b>Ի՞նչ ժամկետում կկատարվի առաքումը</b><br />
    Առաքումը կատարվում է 1-2 աշխատանքային օրվա ընթացքում (առաքումները սկսվում են 09:00-ից մինչ 21:00 բացառությամբ կիրակի օրերի):<br /><br />
    <b>Հնարավո՞ր է առաքումը տեւի 2 օրից ավել</b><br />
    2 օրից ավել առաքումները կարող են տեւել բացառիկ դեպքերում, որոնց մասին հաճախորդին նախապես կտեղեկացվի<br /><br />
    <b>Ես ցանկանում եմ , որ առաքումը կատարվի մի քանի օր հետո</b><br />
    Առցանց գնման ժամանակ հնարավոր է ապրանքը առաքել ըստ Ձեր ցանկության 7 աշխատանքային օրվա ընթացքում, դրա համար անհրաժեշտ է լրացումներում նշել հստակ առաքման օրը եվ ժամը:<br /><br />
    <b>Ինչպիսի՞ն են վճարովի առաքումների պայմանները</b><br />
    Մենք առաջարկում ենք առաքման օպտիմալ տարիֆային համակարգ, համաձայն որի որոշակի գումարից ավել գնումների դեպքում առաքումը կիրականացվի անվճար, հակառակ դեպքում կհաշվարկվի ըստ սահմանված գնացուցակի: Գնացուցակին ծանոթանալու համար այցելեք կայքի ՛՛Մեր մասին՛՛→ ՛՛Ինչպես ենք առաքում՛՛:<br /><br />
    <b>Ես ստացել եմ ապրանքները, և հետո պարզել է, որ կան վնասված կամ թերի ապրանքներ</b><br />
    Առաքման պահին պետք է ստուգեք ապրանքների որակական և քանակական խնդիրները (վնասված, թերի), և այդ դեպքում չեք ընդունում նշված ապրանքը, ապրանքագրի մեջ կատարում եք համապատասխան գրառումները, այնուհետև 1 աշխատանքային օրվա մեջ ապրանքը փոխարինվում է նորով:
  </>,
}];

const specialProductsHelp = <>
  <p>«Ալֆա Ֆարմ»-ը հնարավորություն է տալիս իր օգտատերերին կուտակել միավորներ` գնելով անհրաժեշտ դեղորայք, կոսմետիկա, մանկական և այլ բժշկական պարագաներ։</p>
  <p>Դուք կարող եք ունենալ առավելագույնը 2 հատուկ ապրանք, որից կուտակումը կազմում է 6%։</p>
  <p>Հատուկ ապրանքները հնարավոր է փոխել 3 ամիսը մեկ անգամ, իսկ մանկական կատեգորիային պատկանող ապրանքների դեպքում` ամիսը մեկ անգամ։</p>
  <p>Որոշ ապրանքներ կազմում են բացառություններ և որպես «հատուկ ապրանք» չեն կարող ընտրվել։</p>
</>

// @ts-ignore
export default {
  alfa_pharm: 'Ալֆա-Ֆարմ',
  bonusayin_cragir:' Ալֆա-Ֆարմ դեղատների ցանցը 01.11.2016թ.-ից գործարկել էհաճախորդների խրախուսման բոնուսային ծրագիր, որը հնարավորությունէ տալիս հաճախորդներին կատարելով գնումներ Ալֆա-Ֆարմ դեղատներից՝դրանց դիմաց կուտակել միավորներ եւ ծախսել Ալֆա-Ֆարմի դեղատներումհետագա գնումներ կատարելիս:',
  karoqeq__gnum_katarel:'«Ալֆա Քարտ» կարող եք ձեռք բերել Ալֆա-Ֆարմ դեղատների ցանցիցանկացած մասնաճյուղից գնումներ կատարելիս։',
  alfa_bonusayin_ctagir:'«Ալֆա Քարտ» - Բոնուսային ծրագիր',
  alfa_text1:'«ԱլֆաՔարտ» բոնուսային կուտակային ծրագիրը հնարավորություն է ընձեռում հաճախորդներին կատարել գնումներ «Ալֆա-Ֆարմ դեղատներից,դրանց դիմաց կուտակել միավորներ եւ ծախսել դրանք`մաս-մաս կամ ամբողջությամբ(1 միավորը համարժեք է 1 դրամի): Միավորները կուտակվում են կախված հաճախորդի միանվագ կատարված գնումների գումարի չափից`ըստ հետեւյալ սանդղակի.«ԱլֆաՔարտ» բոնուսային կուտակային ծրագիրը հնարավորություն է ընձեռում հաճախորդներին կատարել գնումներ «Ալֆա-Ֆարմ դեղատներից,դրանց դիմացկուտակել միավորներ եւ ծախսել դրանք`մաս-մաս կամ ամբողջությամբ(1 միավորը համարժեք է 1 դրամի): Միավորները կուտակվում են կախված հաճախորդի միանվագ կատարված գնումների գումարի չափից`ըստ հետեւյալ սանդղակի.',
  alfa_text2:'Ներկայացնելով «Ալֆա Քարտ»-ը կուտակեք միավորներ ըստ հետեւյալ սանդղակի.',
  point_1:'2 միավոր յուրաքանչյուր 100 դրամի դիմաց` մինչեւ 10 000 դրամ միանվագ գնում կատարելու դեպքում',
  point_2:'3 միավոր յուրաքանչյուր 100 դրամի դիմաց` 10 000-ից մինչեւ 20 000 դրամ միանվագ գնում կատարելու դեպքում',
  point_3:'5 միավոր  յուրաքանչյուր 100 դրամի դիմաց` 20 000 դրամ եւ ավել միանվագ գնում կատարելու դեպքում',
  point_4:'+1 լրացուցիչ միավոր յուրաքանչյուր 100 դրամի դիմաց` 40 000 դրամ եւ ավել միանվագ գնում կատարելու դեպքում',
  point_5:"+1 լրացուցիչ միավոր յուրաքանչյուր 100 դրամի դիմաց՝  կիրակի օրերին գնումներ կատարելիս",
  barcr_miavorner:'Նաեւ հնարավորություն ունեք կուտակել բարձր միավորներ`',
  barcr_miavorner_1:'ընտրեք կամայական 2 Հատուկ ապրանքատեսակ եւ կուտակեք ֆիքսված 6 միավոր յուրաքանչյուր 100 դրամի դիմաց: Հատուկ ապրանքները հնարավոր է փոփոխել ամեն 3 ամիսը մեկ, իսկ մանկական ապրանքները, որոնք Հատուկ ապրանք են ընտրված՝ ամիսը մեկ:',
  barcr_miavorner_2:'կուտակեք հատուկ բարձր միավորներ յուրաքանչյուր 100 դրամի դիմաց` հետեւյալ ապրանքանիշերի ապրանքատեսակները գնելիս.',
  standart_kutakman_sandxak:'Վերոնշյալ կուտակումների դեպքում ստանդարտ կուտակման սանդղակը չի գործում։',
  info_price_1:'*Ցածր միավորներ կարող են տրամադրվել կամ ընդհանրապես չտրամադրվել ընկերության կողմից սահմանված որոշ ապրանքախմբերի համար,որոնք սովորաբար  վաճառվում են ցածր գներով կամ hատուկ զեղչով:',
  info_price_2:'* Առանձին ակցիաների դեպքում դրանց կուտակման պայմանները սահմանվում են առանձին-առանձին',
  info_price_3:'* Գործող զեղչերի դեպքում «ԱլֆաՔարտ» կիրառելիս ապրանքը չի զեղչվի եւ կատարված գնման չափով կգործի կուտակում ըստ ստանդարտ կուտակման սանդղակի։',
  info_price_4:'*  Կուտակված միավորներն օգտագործելիս դրանց դիմաց նոր միավորներ չեն կուտակվում։',
  info_cart_1:'Մեկ տարուց ավել քարտը չօգտագործելու դեպքում այն կարգելափակվի եւմիավորները կզրոյացվեն:',
  info_cart_2:'«Ալֆա Քարտ» - Բոնուսային ծրագիր կորպորատիվ հաճախորդների համար',
  info_cart_3:'«ԱլֆաՔարտ» կորպորատիվ հաճախորդների բոնուսային կուտակային ծրագիրը հնարավորություն է ընձեռում հաճախորդներին կատարել գնումներ «Ալֆա-Ֆարմ դեղատներից,դրանց դիմաց կուտակել միավորներ եւ ծախսել`մաս-մաս կամ ամբողջությամբ(1 միավորը համարժեք է 1 դրամի):Միավորները կուտակվում են կախված հաճախորդի միանվագ կատարված գնումների գումարի չափից`ըստ հետեւյալ սանդղակի.',
  point_6:'6 միավոր յուրաքանչյուր 100 դրամի դիմաց` մինչեւ 10 000 դրամ միանվագ գնում կատարելու դեպքում',
  point_7:'7 միավոր յուրաքանչյուր 100 դրամի դիմաց` 10 000-ից մինչեւ 20 000 դրամ միանվագ գնում կատարելու դեպքում',
  point_8:'9 միավոր յուրաքանչյուր 100 դրամի դիմաց` 20 000 դրամ եւ ավել միանվագ գնում կատարելու դեպքում',
  qartapan_info:'Քարտապանը հնարավորություն ունի կուտակել բարձր միավորներ`.',
  info_point_1:'ընտրելով կամայական 2 Հատուկ ապրանքատեսակ՝ կուտակվի ֆիքսված 6 միավոր յուրաքանչյուր 100 դրամի դիմաց: Հատուկ ապրանքները հնարավոր է փոփոխել ամեն 3 ամիսը մեկ, իսկ մանկական ապրանքները, որոնք Հատուկ ապրանք են ընտրված՝ ամիսը մեկ:',
  info_point_2:'կկուտակվեն հատուկ բարձր միավորներ յուրաքանչյուր 100 դրամի դիմաց` հետեւյալ ապրանքանիշերի ապրանքատեսակները գնելիս.',



  special_product_confirm: 'Դուք վստա՞հ եք, որ ցանկանում եք տվյալ ապրանքն դարձնել որպես հատուկ ապրանք',
  special_product: "Հատուկ ապրանք",
  special_products_help: specialProductsHelp,
  expired_text: "Ժամկետը լրացել է",
  expire_text: "Ժամկետը լրանում է",
  price_offer: "Ստանալ գնային առաջարկ",
  card_info_title: 'Ինչ է Ալֆա Քարտը',
  card_info: cardInfo,
  date_new_to_old: "Ամենանոր",
  added: "Ավելացված է",
  verificationCode: "Հաստատման կոդ",
  language_label: "Հայ",
  i_need: "Ինձ անհրաժեշտ է",
  wish_list: "Ցանկեր",
  favorites: "Նախըտրելի",
  orders: "Պատվերներ",
  order_history: "Պատվերների պատմություն",
  cart: "Զամբյուղ",
  contact_address: "ՀՀ ք. Երևան, Շիրակի փ. 1/68",
  log_in: "Մուտք",
  log_in_title: "ՄՈՒՏՔ ԳՈՐԾԵԼ",
  filter: "Ֆիլտր",
  all_categories: "Բոլոր բաժինները",
  empty_favorites_list: 'Հավանած ապրանքների ցանկը դատարկ է',
  empty_carts_list: 'Քարտերի ցանկը դատարկ է',
  empty_registrations_list: 'Գրանցումների ցանկը դատարկ է',
  empty_medical_history: 'Թափուր աշխատատեղերի ցանկը դատարկ է',
  buy_bundle_promotion: "Գնեք նշված ապրանքները միասին և ստացեք համապատասխան կուտակումները:",
  empty_orders_list: 'Պատվերների ցանկը դատարկ է',
  empty_special_products: 'Հատուկ ապրանքների ցանկը դատարկ է',
  empty_address_list: 'Հասցեների ցանկը դատարկ է',
  empty_prescriptions_list: 'Դեղատոմսերի ցանկը դատարկ է',
  empty_tenders_list: 'Տենդերների ցանկը դատարկ է',
  yes: 'Այո',
  no: 'Ոչ',
  about_us: "Մեր մասին",

  about_us_first_1: "«Ալֆա Ֆարմ» դեղագործական ընկերությունը հիմնադրվել է 1996 թ.-ին: Ներկայումս ընկերությունը զբաղեցնում է առաջատար դիրք Հայաստանի դեղագործական շուկայում և շուրջ 20 տարի հաջողությամբ զբաղվում է դեղամիջոցների ներկրմամբ, մեծածախ և մանրածախ առևտրով:",
  about_us_first_2: "Ընկերության հիմնադիրներ են հանդիսանում  հայաստանի դեղագործական ոլորտում բազմամյա փորձ ունեցող անձիք, որոնց մասնագիտական և կազմակերպչական ունակությունների շնորհիվ ընկերությունը բարձրորակ ծառայություններ է մատուցում հանրությանը, ինչպես նաև տարբեր ժամանակահատվածներում, որպես ընկերության բաժնետեր են հանդիսացել  «Վերակառուցման և Զարգացման Եվրոպական Բանկը» (EBRD) և դեղագործական ոլորտի այլ խոշոր եվրոպական ներդրողներ:",
  about_us_first_3: "Ընկերությունն իրականացնում է ուղղակի ներմուծումներ ավելի քան 100 համաշխարհային առաջատար արտադրողներից` այդ թվում Եվրոպայից, ԱՄՆ-ից, Ռուսաստանից, ԱՊՀ երկրներից, Հնդկաստանից եւ այլն, միաժամանակ համագործակցում է նաեւ տեղական արտադրողների հետ: Մեր գործընկերներն են հանդիսանում այնպիսի հայտնի ընկերություններ ինչպիսիք են` Les Laboratories Servier, Sanofi-Aventis, Abbott, Berlin-Chemie AG, Novartis Consumer, Bayer Consumer, Hoffman-La Roche, Nycomed Austria, Pfizer և այլն:",
  first_2: "Ընկերության հիմնադիրներ են հանդիսանում  հայաստանի դեղագործական ոլորտում բազմամյա փորձ ունեցող անձիք, որոնց մասնագիտական և կազմակերպչական ունակությունների շնորհիվ ընկերությունը բարձրորակ ծառայություններ է մատուցում հանրությանը, ինչպես նաև տարբեր ժամանակահատվածներում, որպես ընկերության բաժնետեր են հանդիսացել  «Վերակառուցման և Զարգացման Եվրոպական Բանկը» (EBRD) և դեղագործական ոլորտի այլ խոշոր եվրոպական ներդրողներ:",

  about_clinic: 'Կլինիկայի մասին',
  doctor: "Բժիշկ",
  service: "Ծառայություն",
  services: "Ծառայություններ",
  services_text: "«Ալֆա Ֆարմ» ընկերության մեծածախ վաճառքի բաժնի հիմնական նպատակը ՀՀ բոլոր դեղատներին որակյալ դեղորայքով, հիգիենայի պարագաներով, մանկական սննդով և անհրաժեշտ այլ տեսականիով ապահովելն է: Մենք առաջարկում ենք ծառայություններ հետևյալ առավելություններով`",
  business: "Բիզնես",
  become_partner: "Դարձեք գործընկեր",
  how_to_become_a_partner: "Ինչպես դառնալ գործնկեր",
  vacancies: "Աշխատանք",
  how_to_order_online: "Ինչպես գնել օնլայն",
  financial_statements: "Ֆինանսական հաշվետվություններ",
  fs1: '«Ալֆա-Ֆարմ» ՓԲԸ տարեկան ֆինանսական հաշվետվություն 2022թ․',
  fs2: '«Ալֆա-Ֆարմ Իմպորտ» ՓԲԸ տարեկան ֆինանսական հաշվետվություն 2022թ․',
  fs3: '«Ալֆա-Ֆարմ» ՓԲԸ խմբի (խմբավորված) տարեկան ֆինանսական հաշվետվություն 2022թ.',
  fs4: '«Ալֆա-Ֆարմ» ՓԲԸ տարեկան ֆինանսական հաշվետվություն 2023թ․',
  fs6: '«Ալֆա-Ֆարմ» ՓԲԸ խմբի (խմբավորված) տարեկան ֆինանսական հաշվետվություն 2023թ.',
  fs5: '«Ալֆա-Ֆարմ Իմպորտ» ՓԲԸ տարեկան ֆինանսական հաշվետվություն 2023թ․',
  how_to_order_online_text: "Օնլայն գնում կատարելու համար կարող եք գրանցվել և մուտք գործել համակարգ, ինչը հնարավորություն կտա ստեղծել ձեր անձնական հաշիվը, որտեղ.",
  how_to_order_online_text_li_1: "Կհետևեք պատվերի ընթացքին,",
  how_to_order_online_text_li_2: "Կպահպանվի ձեր պատվերների պատմությունը,",
  how_to_order_online_text_li_3: "Անվճար ձեռք կբերեք կուտակային քարտ,",
  how_to_order_online_text_li_4: "Կպահպանեք նախընտրելի ապրանքների ցանկը,",
  how_to_order_online_text_li_5: "ԵՎ շատ այլ հնարավորություններ կստանաք:",
  how_to_order_online_text_2: "Կարող եք օնլայն գնում կատարել նաև առանց կայք մուտք գործելու՝ մասնավորապես․",
  how_to_order_online_text_2_li_1: "Ներբեռնելով «Alfa-Pharm» բջջային հավելվածը",
  how_to_order_online_text_2_li_2: "Ուղարկելով հաղորդագրություն մեր սոցցանցերի էջերին կամ",
  how_to_order_online_text_2_li_3: "Զանգահարելով 060 700 500 ներք․ 1 հեռախոսահամարով",
  how_to_order_online_text_2_li_4: "Պատվիրել կայքի միջոցով, որպես հյուր (առանց օգտահաշիվ մուտք գործելու)։",
  how_to_order_online_text_3: "-ում օնլայն գնելու համար անհրաժեշտ է․",
  how_to_order_online_text_3_li_1: "Սեղմել «Օնլայն դեղատուն» ⇒ ընտրել ձեզ անհրաժեշտ կատեգորիան կամ փնտրել անհրաժեշտ ապրանքը որոնման դաշտում,",
  how_to_order_online_text_3_li_2: "Ընտրել ապրանքը",
  how_to_order_online_text_3_li_3: "Ընտրել քանակը (տուփ/հատ),",
  how_to_order_online_text_3_li_4: "Սեղմել «ավելացնել» կոճակը,",
  how_to_order_online_text_3_li_5: "Նշել առաքման հասցեն կամ նշել դեղատունը որտեղից ցանկանում եք վերցնել պատվերը,",
  how_to_order_online_text_3_li_6: "Նշել առաքման նախընտրելի ժամը կամ նշել «հնարավորինս շուտ»,",
  how_to_order_online_text_3_li_7: "Ընտրել վճարման տեսակը,",
  how_to_order_online_text_3_li_8: "Սեղմել «հաստատել» կոճակը։",
  how_to_order_online_text_4: "Մեր առաքիչն օպերատիվ կերպով կառաքի Ձեր գնումը նշված հասցեով։",
  how_to_order_online_information: "Տեղեկացնում ենք նաև, որ օնկոլոգիական հիվանդությունների բուժման համար նախատեսված դեղամիջոցները Ալֆա-Ֆարմի օնլայն դեղատան միջոցով ենթակա չեն վաճառքի և չեն առաքվում։ Օնկոլոգիական հիվանդությունների բուժման համար նախատեսված դեղորայքը ձեռք բերելու համար կարող եք մոտենալ Ալֆա-Ֆարմի ք․ Երևան Մ․ Մաշտոցի 31/10 և ք․ Երևան Խ․ Աբովյան 38 հասցեների մասնաճյուղեր։",
  how_to_order_online_information_text_1: "Արդյո՞ք գնված դեղորայքը ենթակա է ետ վերադարձի․",
  how_to_order_online_information_text_2: "ՀՀ կառավարության 2002 թվականի հունվարի 30-ի N 77 որոշմամբ ",
  how_to_order_online_information_text_3: "նմանօրինակ ապրանքներով փոխարինվելու կամ վերադարձնելու ոչ ենթակա պատշաճ որակի ոչ պարենային ապրանքների ցանկում են ներառվել նաև․",
  how_to_order_online_information_text_4: "տնային պայմաններում հիվանդությունների կանխարգելման և բուժման համար (մետաղից, ռետինից, տեքստիլ և այլ նյութերից առողջարարության (կազդուրիչ) և հիգիենայի առարկաներ, բժշկական գործիքներ, սարքեր ու ապարատներ, բերանի խոռոչի հիգիենայի միջոցներ, տեսողության լինզաներ, երեխաների խնամքի առարկաներ), դեղորայք,",
  how_to_order_online_information_text_5: "անձնական հիգիենայի առարկաներ (ատամի խոզանակներ, սանրեր, մազակալներ, բիգուդիներ, կեղծամներ, շինյոններ և այլն),",
  how_to_order_online_information_text_6: "պարֆյումերակոսմետիկական ապրանքներ՝ բացառությամբ օծանելիքի։",
  what_is_alfa_card: "Ինչ է Ալֆա քարտը",
  contact_us: "Հետադարձ կապ",
  default: "Հիմնական",
  make_default: "Դարձնել հիմնական",
  copyright: "Բոլոր իրավունքները պաշտպանված են",
  enter_your_phone_number: "Մուտքագրեք հեռախոսահամարը",
  contract: "Պայմանագիր",
  faq: "Հաճախ տրվող հարցեր",
  faq_texts: faqTexts,
  confidentiality_conditions: "Գաղտնիության քաղաքականություն",
  products_exchange_and_return: "Ապրանքների փոխարինում և վերադարձ",
  download_application: "Ներբեռնեք հայտը",
  download_text: "Գրանցվեք և ստացեք 5000 iBonus",
  not_a_member: "Եթե դեռ գրանցված չեք",
  a_member: "Եթե ունեք գործող հաշիվ",
  sign_up: "Գրանցվել",
  book: "Ամրագրել",
  email: "Էլ. հասցե",
  password: "Գաղտնաբառ",
  restore_password: "Վերականգնել գաղտնաբառը",
  social_login: "Մուտք անձնական էջերով",
  already_a_member: "Գրանցվա՞ծ եք",
  next: "Հաջորդ",
  next_step: "Հաջորդը",
  aply: "Կիրառել",
  accumulative_bonus: "Կուտակվող բոնուս",
  accumulative_bonus_master_card: "Կրկնակի բոնուս Mastercard-ով վճարելիս ",
  accumulative_bonus_visa_card: "Զեղչված արժեք Visa քարտով վճարելիս",
  accumulative_bonus_visa_card_guest: "Զեղչից օգտվելու համար անհրաժեշտ է ",
  order: "Պատվիրել",
  fill_your_information: "Լրացրեք Ձեր տվյալները",
  order_checkout: "Պատվերի ձևակերպում",
  add: "Ավելացնել",
  add_credit_card: "+Ավելացրեք նոր քարտ",
  delete_credit_card: "Ցանկանու՞մ եք ջնջել ձեր պահված քարտը:",
  what_do_you_need_today: "Ի՞նչ է Ձեզ անհրաժեշտ այսօր",
  today: "Այսօր",
  appointments_cancel: "Չեղարկել գրանցումը",
  appointments_cancel_text: "Դուք վստա՞հ եք, որ ցանկանում եք չեղարկել գրանցումը",
  prescription_delete: "Ջնջել դեղատոմսը",
  prescription_delete_text: "Դուք վստա՞հ եք, որ ցանկանում եք ջնջել դեղատոմսը",
  continue_with: (content: string) => `Շարունակել ${content}-ով`,
  available_days: "Հասանելի օրեր",
  create_request: "Ստեղծել հարցում",
  category: "Կատեգորիա",
  choose: "Ընտրել",
  quantity: "Քանակ",
  write: "Լրացնել",
  m_u: "Չ/մ",
  description: "Նկարագրություն",
  attach_file: "Կցել ֆայլ",
  phone_number: "Հեռախոսահամար",
  name: "Անուն",
  surname: "Ազգանուն",
  send: "Ուղարկել",
  add_your_information: "Ավելացնել Ձեր տեղեկատվությունը",
  request_success: "Ձեր հարցումը ուղարկված է",
  basket_save_success: "Զամբյուղը պահպանված է",
  order_create_success: "Ձեր պատվերն ուղղարկված է",
  out_of_stock_delete_confirm: "Նշված ապրանքը առկա չէ։ Պատվերը շարունակելու համար հեռացրեք այն։ Դուք ուզու՞մ եք հեռացնել այն։",
  contact_success: "Ձեր հաղորդագրությունն ուղղարկված է",
  personal_data_success: "Անձնական տվյալները փոխված են",
  phone_verify_success: "Հեռախոսահամարը փոխված է",
  phone_code_send_success: "Ստուգման կոդը ուղարկված է",
  email_send_success: "Ստուգման հղումը ուղարկվել է նշված Էլ. հասցեին",
  checkout_promo_address_error: "Տրամադրեք հասցեն",
  gift_success: "Դուք ունեք նվեր",
  gift: "Նվեր",
  day_off: "Հանգստի օր",
  monday: "Երկ.",
  tuesday: "Երք.",
  wednesday: "Չրք.",
  thursday: "Հնգ.",
  friday: "Ուրբ.",
  saturday: "Շբթ.",
  sunday: "Կրկ.",
  my_orders: "Պատվերները",
  my_requests: "Հարցումները",
  my_companies: "Ընկերությունները",
  my_registrations: "Գրանցումներ",
  medical_history: "Բժշկական պատմություն",
  special_products: "Հատուկ ապրանքներ",

  no_such_promo  : "Պրոմո կոդը չի գտնվել",
  card_missing : "Բոնուս քարտն առկա չէ",
  invalid_card : "Հասանելի չէ տվյալ բոնուս քարտը",
  promo_limit_expired : "Օգտագործման սահմանաչափը լրացել է",
  does_not_make_sense : "Պրոմո կոդին վերաբերող ապրանք չկա",
  card_limit_expired : "Քարտին պրոմո կոդի հասանելիության սահմանաչափը սպառվել է",
  promo_percent_is_smoller: "Պրոմո կոդը չաշխատեց՝ առկա է ավելի շահավետ ակցիա",
  delevery_does_not_make_sense: "Պրոմոկոդը չգործեց, արդեն իսկ առկա է անվճար առաքում",
  not_valid_time: "Պրոմոկոդը գործում է ժամը 12։00-ից 17։00-ն։",
  not_valid_promo_limit_expiered: "Պրոմոկոդի օգտագործման քանակը սպառված է:",
  promocode_message_1: "Պրոմոկոդը օգտագործելու համար անհրաժեշտ է ",
  promocode_message_2: "գրանցվել",
  promocode_message_3: " Ալֆա-Ֆարմ օնլայն դեղատանը:",
  special_products_replace_fail: (date: string) => `Ապրանքը կարող եք փոխարինել ոչ շուտ քան ${date}`,
  clear_basket: 'Մաքրել զամբյուղը',
  no_search_result: 'Որոնման արդյունք չկա',
  package: 'Տուփ',
  item: 'Հատ',
  my_wallet: "Դրամապանակ",
  my_addresses: "Հասցեները",
  addresses: "Հասցեներ",
  cancel_order: 'Ցանկանու՞մ եք չեղարկել այս պատվերը։',
  order_canceled: 'Պատվերը հաջողությամբ չեղարկված է։',
  log_out: "Դուրս գալ",
  basket_at_least_2000: "Օնլայն պատվերի արժեքը պետք է գերազանցի 2000 դրամը։",
  delete_saved_product_basket: 'Ցանկանու՞մ եք ջնջել ձեր պահված զամբյուղը:',
  delete_product: 'Ջնջել ապրանքը',
  delete_product_from_basket: 'Դուք վստա՞հ եք, որ ցանկանում եք հեռացնել այս ապրանքը',
  delete_basket: 'Ջնջել զամբյուղը',
  delete_all_baskets: 'Դուք վստա՞հ եք, որ ցանկանում եք ջնջել ամբողջ զամբյուղը',
  log_out_question: 'Վստա՞հ եք, որ ցանկանում եք դուրս գալ',
  add_new_address: "+ Ավելացնել նոր հասցե",
  add_address: "Ավելացնել հասցե",
  edit_address: "Փոփոխել հասցեն",
  save: "Պահպանել",
  wrong_password_length: 'Գաղտնաբառը պետք է պարունակի առնվազն 6 նիշ',
  save_cart: "Պահպանել զամբյուղը",
  saved_carts: "Նախընտրելի զամբյուղներ",
  saved_basket: "Նախընտրելի զամբյուղներ",
  default_address: "Նախանշված հասցե",
  full_name: "Ամբողջական անունը",
  first_name: "Անուն",
  last_name: "Ազգանուն",
  message: "Հաղորդագրություն",
  write_a_message: "Գրել հաղորդագրություն",
  promotions: "Հատուկ առաջարկներ",
  address: "Հասցե",
  house: "Բնակարան",
  apartment: "Բնակարան",
  building: "Շինություն",
  entrance: "Մուտք",
  floor: "Հարկ",
  contact_text: contactText,
  contract_text: contractText,
  exchange_return_text: exchangeReturnText,
  confidentiality_conditions_text: confidentialityConditionsText,
  deciphered_prescription: "Վերծանված դեղատոմս",
  deciphered: "Վերծանված",
  edit: "Փոփոխել",
  remove: "Հեռացնել",
  edit_company: "Փոփոխել ընկերությունը",
  add_company: "Ավելացնել ընկերություն",
  add_new_company: "+ Ավելացնել նոր ընկերություն",
  tin: "ՀՎՀՀ",
  billing_address: "Իրավաբանական հասցե",
  delivery_address: "Առաքման հասցե",
  delivery_method: "Առաքման եղանակ",
  date_of_order: "Պատվերի ամսաթիվ",
  contact_person: "Կոնտակտային անձ",
  add_other_address: "+ Ավելացնել այլ հասցե",
  company_name: "Ընկերության անվանում",
  my_account: "Իմ էջը",
  form: "Հայտ",
  only_files: "Միայն ֆայլեր",
  only_files_request_text: "Եթե դուք ժամանակ չունեք հարցումը լրացնելու համար, կարող եք կցել առկա ֆայլեր.",
  about_the_project: "Նախագծի մասին",
  how_we_work: "Ինչպես ենք աշխատում",
  career_apply_success: "Ձեր Հայտը հաջողությամբ ուղարկվել է:",
  the_advantages_of_cooperation: "Համագործակցության առավելությունները",
  city: "Քաղաք",
  region: "Մարզ",
  district: "Շրջան",
  delivery: "Առաքում",
  delivery_fee: "Առաքման վճար",
  bonus_card: "Բոնուս քարտ",
  bonus_card_empty: "Բոնուսների պատմություն առկա չէ",
  mobile_app: "Բջջային հավելված",
  about_delivery_text: "«Ալֆա-Ֆարմ»-ի օնլայն դեղատան առաքումն իրականացվում է ք․ Երևանում, սովորաբար, պատվերի ընդունումից մինչև 2 ժամվա ընթացքում։ Մարզերում առաքումն իրականացվում է՝ պատվերը փոխանցելով Ալֆա-Ֆարմի մոտակա մասնաճյուղեր, սովորաբար, մինչև 3 օրվա ընթացքում, որտեղից հաճախորդը վերցնում է պատվերը։",
  about_bonus_card_text: "«Ալֆա-Ֆարմ»-ի կուտակային քարտը հաճախորդին հնարավորություն է տալիս գնումներից ստանալ կուտակային միավորներ, մուտքագրել կանխավճար իր հաշվին, և դրանք օգտագործել «ԱԼֆա-Ֆարմ»-ի դեղատներից գնումներ կատարելու համար։ Առավել մանրամասն կարող եք ծանոթանալ «Ալֆա քարտի պայմաններ» բաժնում։",
  about_mobile_app_text: "«Ալֆա-Ֆարմ»-ի բջջային հավելվածը հնարավորություն է տալիս ունենալ արագ հասանելիություն օնլայն դեղատանը։ Ձեր կուտակային քարտը միշտ կլինի Ձեր հետ, քանի որ այն հասանելի է բջջային հավելվածում, Դուք կկարողանաք մի քանի հպումով կատարել գնումներ օնլայն դեղատնից, տեսնել դեղատների քարտեզը, ծանոթանալ ապրանքացանկին և կունենաք շատ այլ հնարավորություններ։",
  about_mobile_app_text_2: "Հավելվածը կարող եք ներբեռնել Play Market-ից կամ App Store-ից՝ փնտրելով “Alfa Pharm” անունը կամ սկանավորելով հետևյալ QR կոդերից մեկը։",
  about_the_project_text: aboutTheProjectText,
  how_we_work_text: howWeWorkText,
  adventages_text: adventagesText,
  delivery_text: deliveryText,
  for_partners: "Գործընկերների համար",
  invitation_to_cooperate: "Համագործակցության հրավեր",
  partners_account_login: "Գործընկերների էջի մուտք",
  help_for_partners: "Օգնություն գործընկերների համար",
  follow_us: "Հետևեք մեզ",
  facebook: "Facebook",
  instagram: "Instagram",
  linked_in: "LinkedIn",
  language: "Լեզու",
  ineed_app: "ineed հավելվածը",
  change_password: "Փոխել գաղտնաբառը",
  personal_data: "Անձնական տվյալներ",
  save_changes: "Պահպանել փոփոխությունները",
  verification: "Ստուգում",
  verification_text: "Խնդրում ենք մուտքագրել հաստատման կոդը",
  ok: "Լավ",
  or: "կամ",
  home: "Գլխավոր էջ",
  profile: "Պրոֆիլ",
  profile_page: "Անձնական էջ",
  home_app: "Գլխավոր",
  recipes: "Դեղատոմսեր",
  send_again: "Ուղարկել կրկին",
  features: "Հատկություններ",
  additional_sales: "Լրացուցիչ վաճառք",
  get: "ստացեք",
  off: "զեղչ",
  discount: "Զեղչ",
  and: "և",
  i_bonus: "iBonus",
  bonus: "Բոնուս",
  invited: "Հրավիրված",
  days: "Օր(եր)",
  go_to_checkout: "Գնալ պատվերի հաստատման",
  buy: "Գնել",
  add_to_cart: "Ավելացնել զամբյուղ",
  product_of_the_day: "Օրվա ապրանք",
  add_to_cart_short: "Ավելացնել",
  average_price_of_previous_month: "Նախորդ ամսվա միջին գին`",
  lists: "Ցանկեր",
  other_offers: "Այլ",
  settings: "Կարգավորումներ",
  active: "Ակտիվ",
  completed: "Ավարտված",
  request_forms: "Հարցման ձևաչափը",
  request_files: "Հարցման ֆայլերը",
  finished: "Ավարտված",
  delivered: "Ավարտված",
  pending: "Ընթացիկ",
  canceled: "Չեղարկված",
  failed:'Չստացված',
  attached_to_carrier: 'Ընթացիկ',
  confirmed_by_branch_admin: 'Ընթացիկ',
  not_completed: 'Ընթացիկ',
  ready_to_start:  'Հավաքած',
  started: 'Ճանապարհին է',
  success: "Ավարտված",
  success_book: "Շնորհակալություն, Ձեր գրանցման հայտն ընդունված է։ Վերջինիս կարգավիճակին կարող եք հետևել Ձեր անձնական էջի <<Իմ գրանցումները>> բաժնում։",
  best_selling: "Լավագույն վաճառքներ",
  new_products: "Նոր ապրանքներ",
  alphabetical_a_z: "Այբբենական կարգով Ա-Ֆ",
  alphabetical_z_a: "Այբբենական կարգով Ֆ-Ա",
  price_low_to_high: "Գին` ցածրից բարձր",
  price_high_to_low: "Գին` բարձրից ցածր",
  discount_low_to_high: "Զեղչ` ցածրից բարձր",
  discount_high_to_low: "Զեղչ` բարձրից ցածր",
  buy_again: "Գնել կրկին",
  price: "Արժեք",
  brands: "Արտադրողներ",
  brand: "Արտադրող",
  producers: "Երկրներ",
  producer: "Երկիր",
  active_ingredients: "Ակտիվ բաղադրիչներ",
  active_ingredient: "Ազդող նյութ",
  min: "Նվազագույն",
  max: "Առավելագույն",
  clear_filters: "Մաքրել Ֆիլտրերը",
  clear_all: "Մաքրել բոլորը",
  as_soon_as_possible: "Հնարավորինս շուտ",
  date: "Ամսաթիվ",
  created_date: "Ստեղծման ամսաթիվը",
  end_date: "Վերջնաժամկետ",
  sender: "Ուղարկող",
  add_new_list: "+ Ավելացնել նոր ցանկ",
  payer: "Վճարող",
  pay: "Վճարել",
  add_list: "Ավելացնել ցանկ",
  edit_list: "Փոփոխել ցանկը",
  i: "Ես",
  edit_invited_list: "Փոփոխել հրավիրվածների ցանկը",
  delete: "Ջնջել",
  leave_wish_list: "Դուրս գալ ցանկից",
  no_options: "Ընտրանքներ չկան",
  no_companies: "Ընկերություններ չկան",
  new: "+ Նոր",
  NEW: "ՆՈՐ",
  owner: "Պատվիրատու",
  no_lists: "Ցանկեր չկան",
  choose_all_attributes: "Ընտրեք բոլոր ատրիբուտները",
  requested_products: "Հարցված ապրանք(ներ)ը",
  filter_for_users: "Օգտվողների ֆիլտրացում",
  my: "Իմ",
  copy: "Պատճենել",
  copied_to_clipboard: "Հղումը հաջողությամբ պատճենվել է",
  copied_promocode_to_clipboard: "Պրոմոկոդը հաջողությամբ պատճենվել է։",
  url: "URL",
  confirm_description: "Պետք է հաստատեք այս գործողությունը",
  confirm: "Հաստատել",
  choose_address: "Ընտրել իմ հասցեներից",
  choose_pharmacy: "Ընտրեք դեղատուն",
  choose_time: "Ընտրել ժամը",
  choose_date: "Ընտրեք ամսաթիվը",
  asap: "Հնարավորինս շուտ",
  user_request_ask: "խնդրում է ավելացնել այս ապրանքը",
  apply_online: "Դիմել առցանց",
  prescription: "Դեղատոմս",
  prescriptions: "Դեղատոմսեր",
  add_prescription: "Ավելացնել դեղատոմս",
  medical_institution: "Բուժ. հաստատություն",
  upload_image: "Վերբեռնել լուսանկար",
  upload_prescription_image: "Վերբեռնել դեղատոմս",
  upload: "Վերբեռնել",
  cancel: "Չեղարկել",
  total: "Ընդամենը",
  subtotal: "Ընդհանուր գումար",
  promo_discount: "Promo զեղչ",
  points_:"միավոր",
  Points:"Միավոր",
  point: "Միավոր",
  points: "Միավորներ",
  pointss: "միավոր",
  user_points: "Միավորներ",
  checkout: "Պատվերի հաստատում",
  type: "Տեսակ",
  pricing: "Վճարում",
  additionally: "Լրացուցիչ",
  comment: "Մեկնաբանություն",
  address_comment: "Հասցեի մեկնաբանություն",
  retail_sale: "Մանրածախ վաճառք",
  wholesale_sale: "Մեծածախ վաճառք",
  wholesale_sale_price_list: "Գնացուցակ",
  wholesale_sale_service: "Ծառայություններ",
  wholesale_sale_big_sale: "Մեծածախ Ակցիաներ",
  wholesale_sale_online_sale: "Առցանց վաճառք",
  online_sale_new_website: "Առցանց վաճառք (Նոր կայքէջ)",
  wholesale_promotions: "Մեծածախ ակցիաներ",
  useful_links: "Օգտակար հղումներ",
  about_company: "Ընկերության մասին",
  information: "Տեղեկատվություն",
  contact: "Կապ",
  last_search_results: "Վերջին որոնման արդյունքներ",
  products: "Ապրանքներ",
  product: "Ապրանք",
  see_more: "Տեսնել ավելին",
  pickup: "Վերցնել դեղատնից",
  sale: "Զեղչ",
  sort_by: "Դասակարգել ըստ",
  show_all: "Տեսնել բոլորը",
  search: "Որոնել",
  search_results: "Որոնման արդյունքներ",
  stuff: "Աշխատակազմ",
  popular_categories: "Լավագույն բաժիններ",
  cash: "Կանխիկ",
  i_pay: "IPay",
  post_terminal: "POS-տերմինալ",
  idram: "Idram",
  talcell: "Telcell",
  card: "Քարտ",
  answer_text: "Դուք պատասխանել եք՝",
  bank_transfer: "Բանկային փոխանցում",
  delivery_date: "Առաքման ամսաթիվ",
  pickup_date: "Վերցնելու ամսաթիվ",
  footer_text: "«Ալֆա Ֆարմ» դեղատների ցանցը հանդիսանում է հանրապետությունում ամենամեծ և աշխարհագրորեն սփռված ցանցը:",
  order_a_call: "Պատվիրել զանգ",
  invite: "Հրավիրել",
  invite_your_friend: "Հրավիրեք Ձեր ընկերոջը",
  copy_and_share: "Պատճենեք նշված լինքը և կիսվեք Ձեր ընկերների հետ։",
  earn_bonus_points: "Կուտակեք բոնուսային միավորներ՝ հրավիրելով Ձեր ընկերներին «Ալֆա Ֆարմ» բջջային հավելված:",
  use_the_link: "Օգտագործեք հղումը",
  done: "Հաստատել",
  spin: "Պտտել",
  order_number: "Պատվերի ID",
  accumulated_points:'Կուտակված միավոր',
  used_points:'Օգտագործված միավոր',
  balance:'Մնացորդ',
  status: "Կարգավիճակ",
  repeat: "Կրկնել",
  payment_method: "Վճարման եղանակ",
  product_deleted_warning: "Այս ապրանքը հեռացվել է",
  all_products: "Բոլոր ապրանքները",
  are_you_sure: "Արդյո՞ք վստահ եք",
  are_you_sure_cancel_order: "Վստա՞հ եք, որ ցանկանում եք չեղարկել պատվերը",
  mark_as_read: "Նշել կարդացած",
  written: "Գրված է",
  confirm_new_password: "Հաստատել նոր գաղտնաբառը",
  bonus_count: "Ընդհանուր բոնուս",
  confirm_password: "Հաստատել գաղտնաբառը",
  current_password: "Ընթացիկ գաղտնաբառը",
  new_password: "Նոր գաղտնաբառը",
  choose_password: "Ընտրեք գաղտնաբառը",
  empty_saved_basket_list: 'Նախընտրելի զամբյուղների ցանկը դատարկ է',
  empty_price_list: 'Գնացուցակի ցանկը դատարկ է',
  empty_doctors_list: 'Բժիշկների ցուցակը դատարկ է',
  empty_blogs_list: 'Բլոգերի ցանկը դատարկ է',
  similar: "Միանման",
  empty_card_list: 'Կցված քարտեր չկան',
  similar_products: "Նմանատիպ ապրանքներ",
  sign_up_confirm: <>Ես համաձայն եմ <a target="_blank" role="noreferrer" href={ROUTES.EXCHANGE_RETURN}>դրույթների</a> և <a target="_blank" role="noreferrer" href={ROUTES.CONFIDENTIALITY_CONDITIONS}>պայմանների</a> հետ</>,
  reason: "Պատճառ",
  show_more: "Ցույց տալ ավելին",
  read_more: "Կարդալ ավելին",
  promo_code: "Մուտքագրեք կոդը",
  promoCode: "Պրոմոկոդ",
  thePromoCode: "Պրոմոկոդը",
  apply: "Դիմել",
  special_offers: "Վիտամիններ / Բիոակտիվ հավելումներ",
  suggested_products: "Առաջարկվող Ապրանքներ",
  cosmetics_offers: "Կոսմետիկա",
  orthopedic_products : "Օրթոպեդիկ պարագաներ և կոմպրեսիոն տրիկոտաժ",
  medicines_offers: "Դեղորայք",
  child_offers: "Մանկական",
  seasonal_offers: "Սեզոնային Առաջարկներ",
  additional_sale_label: (fromCount: number) => `Գնեք ${fromCount} և ավելի,`,
  checkout_i_bonus_can_use: (bonus: number, points: number): string => `Դուք կարող եք օգտագործել ${bonus} ${Settings.translations.i_bonus} Ձեր ${points}-ից`,
  receiving_bonus: "Ստացած iBonus",
  use_bonus_points: "Օգտագործել բոնուս միավորներ",
  used_bonus: "Օգտագործված բոնուս",
  gained_bonus: "Կուտակվող բոնուս",
  used_bonus_: "Օգտագործված բոնուս",
  gained_bonus_: "Կուտակված բոնուս",
  no_products: "Ապրանքներ չկան",
  no_addresses: "Հասցեներ չկան",
  no_orders: "Պատվերներ չկան",
  no_requests: "Հարցումներ չկան",
  no_notifications: "Ծանուցումներ չկան",
  categories: "Բաժիններ",
  child_category: "Տեսակ",
  pharmacies: "Դեղատներ",
  online_pharmacy: "Օնլայն դեղատուն",
  online_sales: "Առցանց վաճառք",
  clinic: "Կլինիկա",
  doctors: "Բժիշկներ",
  doctor_consultation: "Բժիշկի Խորհրդատվություն",
  laboratory: "Լաբորատորիա",
  price_list: "Գնացուցակ",
  blog: "Բլոգ",
  news: "Նորություններ",
  tenders: "Տենդերներ",
  order_a_call_success: "Ձեր հայտը հաջողությամբ ընդունված է: Մեր օպերատորը կկապվի ձեզ հետ որքան հնարավոր է շուտ:",
  order_success: "Շնորհակալություն ձեր պատվերը հաստատված է։ Պատվերի մանրամասներին կարող եք ծանոթանալ պատվերների պատմություն բաժնում։",
  order_fail: "Ձեր վճարումը չհաջողվեց։",
  guest_order_success: 'Շնորհակալություն ձեր պատվերը հաստատված է։ Գրանցվեք Ալֆա-Ֆարմ համակարգում և կուտակեք բոնուսներ` կատարելով գնումներ օնլայն դեղատնից։',
  prescription_success: "Շնորհակալություն դեղատոմսի դիտարկման հայտն ընդունված է։ Դեղատոմսը կուսումնասիրվի, և դեղերի ցանկը կուղարկվի Ձեզ հնարավորինս կարճ ժամանակահատվածում։",
  appointment_success: "Շնորհակալություն: Ձեր գրանցման հայտն ընդունված է: Վերջինիս կարգավիճակին կարող եք հետևել Ձեր անձնական էջի «Իմ գրանցումները» բաժնում:",
  availability_at_the_nearest_pharmacy: "Առկայություն մոտակա դեղատանը",
  good_morning: "Բարի լույս",
  out_of_stock: "Առկա չէ",
  add_special_product: "Ավելացնել հատուկ ապրանք",
  of_stock: "Առկա է",
  good_afternoon: "Ողջույն",
  good_evening: "Բարի երեկո",
  show_less: "Ավելի քիչ",
  get_my_order: "Գտնել իմ պատվերը",
  treatment: "Բուժում",
  get_my_order_text: "Խնդրում ենք գրել ձեր էլ.փոստը և կոդը, պատվերի մանրամասները ստանալու համար",
  code: "Կոդ",
  notifications: "Ծանուցումներ",
  insttallApp: "Ներբեռնել հավելվածը",
  installationBonuses: "Գրանցվեք և ստացեք 5000 iBonus",
  email_or_phone: "Էլ. հասցե կամ հեռախոսահամար",
  install: "Տեղադրել",
  success_partner: 'Գործընկերը ավելացավ հաջողությամբ',
  message_sent: 'Ձեր հաղորդագրությունը հաջողությամբ ուղարկվեց:',
  send_request: "Հարցում ուղարկել",
  privacy_policy: "Գաղտնիության քաղաքականությունը",
  privacy_policy_text : PrivacyPolicyText,
  terms_of_use: "Օգտագործման պայմաններ",
  businnes_description: "ineed-ում մենք մեր գործընկերների հետ ձգտում ենք աշխատել այնպես, որ կարողանանք հասնենլ նրանց բիզնեսի զարգացման համար անհրաժեշտ արդյունքներին: Ուղարկեք մեզ հարցում և դարձեք մեր գործընկերը",
  wrong_email: 'Էլ․ հասցեն սխալ է մուտքագրված',
  wrong_password: 'Գաղտնաբառը սխալ է մուտքագրված',
  passwords_do_not_match: 'Գաղտնաբառերը չեն համընկնում',
  draft: 'Նախնական օրինակ',
  please_check_correctness_of_email_or_phone_number: 'Խնդրում ենք ստուգել էլ. փոստի կամ հեռախոսի համարը',
  gender: 'Սեռ',
  date_of_birth: 'Ծննդյան ամսաթիվ',
  pay_with_credit_card: "Վճարել կրեդիտ քարտով",
  male: 'Արական',
  female: 'Իգական',
  not_filled: 'Լրացված չէ',
  open: 'Բաց է',
  closed: 'Փակ է',
  about_us_1:'Ընկերության ժամանակակից լոգիստիկ կենտրոնը զբաղեցնում է 3600 ք/մ տարածք և սարքավորված է առաջնակարգ հոսքագծային տեխնիկայով, որը համապատասխանում է դեղամիջոցների պահպանման, մշակման և բաց թողնման ամենախիստ պահանջներին: Լոգիստիկ կենտրոնի բարձր թողունակությունը հնարավորություն է տալիս ժամանակին և որակյալ կազմակերպել մեր կողմից իրացվող տեսականու առաքումն ավելի քան 1000 դեղատներ և բուժհաստատություններ:',
  about_us_2:'«Ալֆա Ֆարմ» դեղատների ցանցը բաղկացած է 170-ից ավել դեղատներից, այդպիսով հանդիսանալով հանրապետությունում ամենամեծ և աշխարհագրորեն սփռված ցանցը: Ցանցի դեղատները գործում են Երևան, Գյումրի, Վանաձոր, Ստեփանավան, Վայք, Սևան, Մարտունի, Գավառ, Աբովյան, Հրազդան, Բյուրեղավան, Չարենցավան, Աշտարակ, Արմավիր, Արարատ, Կապան քաղաքներում և նախատեսվում է էլ ավելի ընդլայնել ցանցի աշխարհագրությունը, այդպիսով հասանելի դառնալով ՀՀ ողջ տարածքում:',
  about_us_22:'2018թ․-ից սկսած գործում է Ալֆա-Ֆարմի շուրջօրյա առաքման ծառայությունը, որը, որպես օնլայն շուրջօրյա դեղատուն Հայաստանում առաջինն է հիմնադրվել։ Առաքման ծառայությունը տվյալ պահին գործում է միայն ք․ Երևանում, իսկ մարզերում բնակվող հաճախորդները կարող են պատվիրել Ալֆա-Ֆարմի կայքէջից կամ բջջային հավելվածից և ստանալ պատվերը մոտակայքի Ալֆա-Ֆարմի դեղատնից։ Ալֆա-Ֆարմի կայքէջում և բջջային հավելվածում ապրանքների համար նշված գները գործում են միայն առցանց պատվերներ կատարելիս և կարող են տարբերվել դեղատնային ցանցում գործող գներից։',
  about_us_3:'Մեր ընկերության աշխատակազմը բաղկացած է ավելի քան 800 աշխատակիցներից, որոնց թվում են ընկերության ուսուցման կենտրոնում շարունակական կրթություն ստացող բարձրակարգ դեղագետները, լոգիստիկայի մասնագետները, վաճառքի մենեջերները և ղեկավար անձնակազմը: Մեր ամենօրյա աշխատանքի նպատակն է աջակցել տարբեր հիվանդությունների դեմ արդյունավետ պայքարին, օգնել մայրերին ճիշտ կերակրել իրենց երեխաներին, առաջարկել բարձրորակ կոսմետիկա և օպտիկա:',
  bl:"hayerenBl",
  page_not_found:"Էջը չի գտնվել",
  apps:"հավելված",
  get_it: "ՍՏԱՑԻ՛Ր",
  the_first_orders: "առաջին 3 պատվերների համար՝ օգտագործելով",
  banner_bottom_text: "Պրոմոկոդը կարող եք օգտագործել՝ գրանցվելով alfapharm.am կայքէջում կամ AlfaPharm բջջային հավելվածում։",
  items_per_page: "Էջի տարրերը",
  bonus_history: "Բոնուսների պատմություն",
  bonus_history_online: "Բոնուսների պատմություն | օնլայն",
  bonus_history_pharmacy: "Բոնուսների պատմություն | Դեղատուն",













  notification_texts: {
    request_failed: {
      title: "Ձեր հարցումն ավարտված է",
      body: "Ներեցեք, բայց մենք չենք գտել Ձեր կողմից հարցված ապրանքը",
    },
    request_succeeded: {
      title: "Ձեր հարցումն ավարտված է",
      body: "Սեղմեք Ձեր փնտրած ապրանքի մանրամասները տեսնելու համար",
    },
    order_canceled: {
      title: "Ձեր պատվերը չեղարկվել է",
      body: "Սեղմեք մանրամասները տեսնելու համար",
    },
    order_finished: {
      title: "Ձեր պատվերն ավարտված է",
      body: "Սեղմեք մանրամասները տեսնելու եւ բոնուսները ստանալու համար",
    },
    order_idram_failed: {
      title: "Ձեր փոխանցումը չհաջողվեց",
    },
    wish_list_delete: {
      title: "Գնումների ցուցակ է հեռացվել",
      body: "Ցավոք, Ձեր գնումների ցուցակներից մեկը հեռացվել է",
    },
    wish_list_leave: {
      title: "Անդամը լքել է գնումների ցանկը",
      body: "Ցավոք, անդամներից մեկը լքել է գնումների ցանկը",
    },
    wish_list_new_product: {
      title: "Նոր ապրանքատեսակ",
      body: "Նոր ապրանքատեսակ է ավելացվել գնումների ցանկում",
    },
    wish_list_remove_product: {
      title: "Ապրանքատեսակի հեռացում",
      body: "Ապրանքատեսակ է հեռացվել գնումների ցանկից",
    },
    wish_list_product_request: {
      title: "Ապրանքատեսակի ավելացում",
      body: "Գնումների ցանկում օգտատերը ցանկանում է ավելացնել նոր ապրաքատեսակ",
    },
    wish_list_unapprove: {
      title: "Ապրանքատեսակի մերժում",
      body: "Ձեր կողմից հարցված ապրանքատեսակը չի հաստատվել գնումների ցանկում",
    },
    wish_list_approve: {
      title: "Ապրանքատեսակի հաստատոմ",
      body: "Ձեր կողմից հարցված ապրանքատեսակը հաստատվել է գնումների ցանկում",
    },
    wish_list_kick: {
      title: "Գնումների ցանկի անդամակցում",
      body: "Ցավոք, Դուք հեռացվել եք գնումների ցանկից",
    },
    wish_list_new_member: {
      title: "Գնումների ցանկի անդամակցում",
      body: "Նոր անդամ է միացել գնումների ցանկին",
    },
  },
};
